const KE_LAND_BORDERS = [
  { label: "Busia", value: "5bf2994a-550f-4bf3-a80c-9f1728aa48a1" },
  { label: "Isebania", value: "649304b1-634c-447a-a2a1-25603b703dfa" },
  { label: "Loitoktok", value: "dc2a19bc-7196-42da-bd1d-55d1c1b90f75" },
  { label: "LungaLunga", value: "e4cd2ac4-d4b7-43bb-b010-b6fdc6d27e2f" },
  { label: "Lwakhakha", value: "d442cde8-98a6-44c5-b7dd-11b1b0b72c4a" },
  { label: "Malaba", value: "a850146e-235d-46fb-b7b0-b7f8b5d9f85e" },
  { label: "Muhuru Bay", value: "b60579bd-4ccd-4967-8fb2-067f333c063e" },
  { label: "Nadapal", value: "9f60dea7-b721-4f2b-9ef2-dd07cde04327" },
  { label: "Namanga", value: "15861350-c7e4-40dc-b44e-b174a212d9ca" },
  { label: "Moyale", value: "15ba7c13-f7fe-4d23-9849-dabe7f044e7b" },
  { label: "Suam", value: "e0dc6dae-59dc-4366-84e8-e3394f8948e5" },
  { label: "Taveta", value: "e0cac74b-b5ed-4bbc-a2aa-11349f13f8d0" },
]

const KE_AIRLINES = [
  { label: "Air Arabia", value: "ca53e464-6646-42c8-a8ba-44cdb309c68c" },
  { label: "Air Canada", value: "0388c681-2d0e-494a-b9e4-ebc1cf6ce7b7" },
  { label: "Air France", value: "da6ebf5b-e853-4e98-aa81-42e1622695b1" },
  { label: "Air India", value: "b942477a-f03a-41a7-88a3-232d831d0380" },
  { label: "Air Arabia", value: "ca53e464-6646-42c8-a8ba-44cdb309c68c" },
  { label: "AirAsia X", value: "d8e795d8-a1d9-457f-a31c-ed6bb74a92bc" },
  { label: "Airlink", value: "b3960f91-c442-4056-bedf-a8d5524df21c" },
  { label: "Alaska Airlines", value: "4794abfc-d9e1-471e-b898-4bbdcd8bf5f5" },
  { label: "American Airlines", value: "08c20266-138d-422e-913d-b846a6afd813" },
  { label: "Asky Airlines", value: "2eb6491e-5072-4437-b425-033d3b97c14c" },
  { label: "Astral Aviation", value: "3f1a6b7d-4770-4784-879b-43c7297b72f0" },
  { label: "British Airways", value: "dbc342d7-3116-4462-b059-101e6e5321d0" },
  { label: "Cathay Pacific", value: "aa586df9-539b-4cac-a606-729606afcf9b" },
  { label: "China Southern Airlines", value: "526f97b7-a388-49c0-9f38-9d5a191c4adf" },
  { label: "Condor", value: "7b4fccfc-3543-45ac-a32b-95a22cde7680" },
  { label: "Daallo Airlines", value: "9cf6a3f5-6588-49b2-a6dd-9257124cfd26" },
  { label: "Delta Air Lines", value: "82f2c731-308a-4c2e-b846-ee60871fe62e" },
  { label: "Discover Airlines", value: "d8b645a9-2c5d-480c-8f6e-3156e53112c4" },
  { label: "EgyptAir", value: "5c263df0-210a-460a-8367-a6748e74e325" },
  { label: "Emirates", value: "e06857bb-1c0a-4207-84b4-bee92116a8d9" },
  { label: "Enter Air", value: "960b6b40-06b4-4e4b-9151-1fa4b6ee2538" },
  { label: "Etihad", value: "76120e5c-b13a-4f58-a1c5-fe6aff901324" },
  { label: "Ethiopian Airlines", value: "55b6f9e1-7ea1-4655-8ba8-1731411a59d4" },
  { label: "Finnair", value: "792b129b-eb29-427f-ba15-6da58a1f2c64" },
  { label: "Fly Dubai", value: "a4865a71-e8ff-41b8-99a6-1d7c53a47b20" },
  { label: "Freedom Airline Express", value: "c397d351-6dd2-4954-a2e4-31c7332d57eb" },
  { label: "Freedom Airlines", value: "eec8c7fc-458c-4916-8525-412e86a74ab2" },
  { label: "Gulf Air", value: "d73f3966-631e-445d-84d7-08a5c9b44170" },
  { label: "HiSky Europe", value: "0d89fce4-8d61-482b-915d-724abf4a993d" },
  { label: "Iberia", value: "b684a080-f079-44e1-87b0-96e9ec13e6e6" },
  { label: "i-Fly Air", value: "595f2eba-8c59-4888-bd59-323e6355b8fa" },
  { label: "IndiGo", value: "0b428433-1712-4658-abd2-21ff08dd9342" },
  { label: "Japan Airlines", value: "35ba130d-8056-4043-9fd1-7e9173b83aef" },
  { label: "Jambojet", value: "76ff0f4d-4d31-4c47-b6fb-9d426b426d12" },
  { label: "JetBlue Airways", value: "2978937e-d383-47de-bed0-b54a432821b9" },
  { label: "Jubba Airways", value: "cdfea86e-c61e-450c-b277-9ece0b7aa8a7" },
  { label: "Kenya Airways", value: "b10a0664-b037-4500-a2e2-63b85b783f76" },
  { label: "KLM", value: "f7f74cc3-7af7-4fdb-b721-97d65ff22305" },
  { label: "Korean Air", value: "54c6edc0-a8a6-442c-967c-aa29daae4b5c" },
  { label: "Kuwait Airways", value: "d4f9b666-e8ee-48ce-b736-c5114be66bca" },
  { label: "LAN Airlines", value: "4af2b6b2-9301-412f-b49f-8f4f673355c2" },
  { label: "Linhas A", value: "fbfb5a04-d3f6-4d45-9146-b4a4d49c85bb" },
  { label: "Lot", value: "a7e75b9e-d41f-4184-95d2-fd4b8809cc98" },
  { label: "Lufthansa", value: "162d51e5-8fcc-4083-969d-91d5948e58ad" },
  { label: "Malaysia Airlines", value: "32c354a3-00e5-45db-a745-5473fece7c7e" },
  { label: "Malawian Airlines", value: "8e89f651-3871-42f7-85b1-5a9d3408397d" },
  { label: "Qatar Airways", value: "540592d0-6ed0-43c5-9d63-e430c29aaa97" },
  { label: "Royal Air Maroc", value: "6dacc3e0-6245-48c6-8a79-eaf8fb0fe479" },
  { label: "Safarilink Aviation", value: "ef88a5af-818f-43ac-a9a7-70f228de96a9" },
  { label: "Saudia", value: "c96cca58-de82-458f-a8c1-85d3068a3e02" },
  { label: "Sichuan Airlines", value: "c7be22b3-01ea-436a-bfc2-161c916e0762" },
  { label: "Smartwings", value: "2bb1d0a8-0bd2-4d54-97f3-d997850bae0b" },
  { label: "Swiss International Air Lines", value: "ad949d75-2138-422b-80d0-446fc2090b9f" },
  { label: "Taquan Air", value: "0272b9d4-2ed4-4a30-b9c1-a40ca50f6a15" },
  { label: "Turkish Airlines", value: "967f0f2f-77aa-45d5-a804-c9d8ebad4c21" },
  { label: "Other", value: "other" }
] 

const KE_AIRPORTS = [
  { label: "Eldoret International Airport", value: "2d29dc86-c9e8-4b69-a0ad-04e838119d0e" },
  { label: "Isiolo Airport", value: "9a89c617-8434-4e01-8da1-75def4598191" },
  { label: "Jomo Kenyatta International Airport", value: "b268977d-4556-4253-9388-b774ec1b4df2" },
  { label: "Kisumu Airport", value: "0abfef78-1415-49bd-8916-a840e031f75a" },
  { label: "Lokichoggio Airport", value: "fa88f091-d196-4b5d-adc1-01e60b2238bc" },
  { label: "Malindi Airport", value: "89af3040-05b0-4189-b030-198bf9dc9f68" },
  { label: "Mombasa International Airport", value: "7bd265a2-4d86-43ce-a8cb-bb46b8fa5ce3" },
  { label: "Wajir Airport", value: "75b13ea1-b2ad-4fcc-98e4-f41f97fe9fec" },
  { label: "Wilson Airport", value: "df624426-dbcd-4781-bb49-48c09feb8bf9" }
] 

const KE_FLIGHTS = {
  "cdfea86e-c61e-450c-b277-9ece0b7aa8a7": [],
  "c7be22b3-01ea-436a-bfc2-161c916e0762": [
    {
      "label": "7140",
      "value": "82950d16-159c-4b85-9d0d-942a8cb4d9b2"
    }
  ],
  "3f1a6b7d-4770-4784-879b-43c7297b72f0": [
    {
      "label": "242",
      "value": "172009ca-5be1-4927-8e24-c9bd35a2ea78"
    },
    {
      "label": "404",
      "value": "4120d436-d92f-47e9-9731-8edbacdb618e"
    },
    {
      "label": "8V10",
      "value": "77addd86-2e14-4946-833f-7a0d53bd15f2"
    },
    {
      "label": "8V20",
      "value": "26d878f5-bb4b-4f0e-895f-82505b86c46b"
    },
    {
      "label": "8V21",
      "value": "b0547e62-a89a-4e71-a43d-bb36b9c96e30"
    },
    {
      "label": "8V25",
      "value": "ced67ab9-f70a-4595-b3e6-c75c83a0b4fd"
    },
    {
      "label": "8V45",
      "value": "6239d6c6-3630-407c-94e9-bfc8ffe3d048"
    },
    {
      "label": "8V5",
      "value": "1e58a2bb-ca26-424d-a48a-ef1f2b0bf5c1"
    },
    {
      "label": "8V50",
      "value": "16f6e535-d7e3-4b19-a6ea-84379ee502dd"
    },
    {
      "label": "8V60",
      "value": "0ad59113-e5d0-45c6-9f84-a738dd7b65be"
    }
  ],
  "b942477a-f03a-41a7-88a3-232d831d0380": [
    {
      "label": "7546",
      "value": "1cf07cbd-d8b0-4d78-854b-76f68e0764f5"
    },
    {
      "label": "7547",
      "value": "0bc5e85f-2d0e-45ab-bb63-3f636e102f1e"
    },
    {
      "label": "7548",
      "value": "208bfa37-e4f4-46ac-8523-303b95ce3869"
    },
    {
      "label": "7549",
      "value": "07f7683a-b06d-471d-8195-23a11c1e8f33"
    },
    {
      "label": "7576",
      "value": "682a0486-b719-4dec-9ff6-49b054caad19"
    },
    {
      "label": "7577",
      "value": "b314b18a-d83c-4a21-ac4f-b8305761218d"
    },
    {
      "label": "7598",
      "value": "743d4e33-a430-4b25-8f38-788b1c5e7b5d"
    },
    {
      "label": "7599",
      "value": "7c2640c1-af0a-45c9-ab70-37b9797b3ded"
    },
    {
      "label": "8051",
      "value": "fcb17d61-2cd1-411d-afcb-93706116df1a"
    },
    {
      "label": "8052",
      "value": "ea16920c-ec10-437a-82d5-fdfd4dcb928b"
    },
    {
      "label": "8053",
      "value": "e7e77884-8d90-411f-8ef3-0c543e86412d"
    },
    {
      "label": "8054",
      "value": "12d5f6c3-abba-4924-bde4-bdfec8ddbdd9"
    },
    {
      "label": "961",
      "value": "6546c820-05d6-42d4-889d-a71f7d9cbca7"
    },
    {
      "label": "962",
      "value": "dc3b8fea-d7a9-45d4-8555-d95b8aac081e"
    }
  ],
  "595f2eba-8c59-4888-bd59-323e6355b8fa": [
    {
      "label": "Y710",
      "value": "41f61eeb-2498-44be-a3ec-7a2e684b4062"
    },
    {
      "label": "Y711",
      "value": "75f70b27-1ce8-4e21-9c89-a0c434d45d5d"
    },
    {
      "label": "Y720",
      "value": "f77cba88-8434-4e94-a60e-1e49df7c6586"
    },
    {
      "label": "Y721",
      "value": "e7be3e1f-b524-4392-a75d-6ec3574154f0"
    }
  ],
  "0272b9d4-2ed4-4a30-b9c1-a40ca50f6a15": [
    {
      "label": "3920",
      "value": "604c2bbe-96f1-4ee1-bba3-461c254097f5"
    },
    {
      "label": "3921",
      "value": "3a134f6f-e57a-40cd-ba0b-6cd2b3d947d2"
    }
  ],
  "d4f9b666-e8ee-48ce-b736-c5114be66bca": [
    {
      "label": "6302",
      "value": "a449a3d2-cfa1-465a-b1e4-5964ecfb06db"
    },
    {
      "label": "6303",
      "value": "0f381790-cb56-4485-8112-616c7c7dbb7c"
    },
    {
      "label": "6322",
      "value": "7b239f28-efb4-44f2-b800-8465a7d5c944"
    },
    {
      "label": "6323",
      "value": "9f936ec8-5782-421b-b297-9a2ae10237da"
    }
  ],
  "792b129b-eb29-427f-ba15-6da58a1f2c64": [
    {
      "label": "6033",
      "value": "dd6f8b4a-e1f0-4957-a83c-409d99bf17f7"
    },
    {
      "label": "6034",
      "value": "d501394d-3b1b-40f2-a1ee-03692d7a876b"
    },
    {
      "label": "6040",
      "value": "50bf1db1-6778-45ba-bb73-1cd1685ddbee"
    }
  ],
  "aa586df9-539b-4cac-a606-729606afcf9b": [
    {
      "label": "9271",
      "value": "40661ccf-5980-4ec6-8bc8-da7423195276"
    },
    {
      "label": "9274",
      "value": "8b7982d1-facc-4a18-981f-d4b80dd8560b"
    },
    {
      "label": "9275",
      "value": "f8aad421-218e-4a99-9c4b-e0f4fa533716"
    },
    {
      "label": "9276",
      "value": "114dc0da-b214-46e6-b74e-c276aeb2e5a1"
    }
  ],
  "0d89fce4-8d61-482b-915d-724abf4a993d": [
    {
      "label": "8361",
      "value": "2cfef95b-c9c3-4cd2-ba62-ff46a5f33bf4"
    }
  ],
  "6dacc3e0-6245-48c6-8a79-eaf8fb0fe479": [
    {
      "label": "5751",
      "value": "4ac77589-6619-4a02-8937-d58fb28deb9e"
    },
    {
      "label": "5752",
      "value": "574c6750-6827-4345-a6bd-af010eb11f3b"
    },
    {
      "label": "5753",
      "value": "ac938a21-06ed-4178-b6b0-45ca9ffdae44"
    },
    {
      "label": "5754",
      "value": "18db3e55-c068-4648-9cf4-b08b64233a74"
    },
    {
      "label": "910",
      "value": "f5bf71a5-fa6d-46c1-a4fa-3ed219d8e68a"
    },
    {
      "label": "9101",
      "value": "84fde3ac-b8ac-4672-89de-633619bfba04"
    },
    {
      "label": "9102",
      "value": "8d326d51-2d51-4578-a0b6-8a41d6ca2aa9"
    },
    {
      "label": "9104",
      "value": "51446714-9902-407f-9dd8-07ff69944470"
    },
    {
      "label": "9105",
      "value": "a4d10620-af24-4bb8-baf1-4a1c56f88c4f"
    },
    {
      "label": "9106",
      "value": "d9fa64d4-b660-47c6-8a6c-de0d1c551527"
    },
    {
      "label": "9107",
      "value": "82948571-50b3-4123-a899-c5e185fe6735"
    },
    {
      "label": "9108",
      "value": "3b9efc03-28f9-460b-b635-0aa9832e614d"
    },
    {
      "label": "9109",
      "value": "4a0de808-e4f6-4b38-ac5d-fa1606804040"
    },
    {
      "label": "911",
      "value": "a749682b-8ca3-4a33-b97d-2635309d8cb8"
    },
    {
      "label": "9113",
      "value": "8ba51833-fd8b-4cbc-87fa-0905fc524b47"
    },
    {
      "label": "9114",
      "value": "9035363c-09a6-424c-9252-2d11a6f9cd73"
    },
    {
      "label": "9115",
      "value": "9c14c1f4-426a-42f2-b55a-02f2bbbf1f44"
    },
    {
      "label": "9116",
      "value": "12bf5ae9-8cf4-47e1-bc08-bee01343a983"
    },
    {
      "label": "9117",
      "value": "4d4126c4-2543-47c3-877b-6e19d44b2220"
    },
    {
      "label": "912",
      "value": "fb931f80-513a-497b-8b2d-fbba389cae16"
    },
    {
      "label": "913",
      "value": "d12be573-4854-4449-996b-2fb2c2d357fc"
    },
    {
      "label": "9453",
      "value": "8392b06d-4d4a-4a8a-a9bc-88cf410be4ef"
    },
    {
      "label": "9454",
      "value": "dd7ab0d3-e1fd-42be-8607-14aa32a803ea"
    }
  ],
  "4af2b6b2-9301-412f-b49f-8f4f673355c2": [
    {
      "label": "6058",
      "value": "29e528d1-4a83-4784-9ef3-582de532f641"
    },
    {
      "label": "6059",
      "value": "7817f0ff-d538-4cbf-ad2f-da4cf743dc4a"
    },
    {
      "label": "6060",
      "value": "7cac2e89-d869-4483-a61e-b5eca2377db2"
    },
    {
      "label": "7452",
      "value": "dec6b6f8-d437-480e-922e-1c482e5c7c4f"
    }
  ],
  "fbfb5a04-d3f6-4d45-9146-b4a4d49c85bb": [
    {
      "label": "7101",
      "value": "1a620f47-244a-40de-9f06-30b4bafe86fe"
    },
    {
      "label": "7117",
      "value": "6a1c770c-df55-4dc5-be89-14e1d2256db6"
    },
    {
      "label": "7203",
      "value": "4819ebdc-c971-4e45-ad2d-6e1c14724c6d"
    },
    {
      "label": "7204",
      "value": "a00612a6-4c4c-400c-a4d1-2f890adacb28"
    },
    {
      "label": "7304",
      "value": "9ed8629e-e5a0-4580-8562-32bf7fef3897"
    },
    {
      "label": "7311",
      "value": "e61f000d-7da5-48a2-a4f8-8499d1a895b7"
    },
    {
      "label": "740",
      "value": "1468d661-cc9f-4287-b8f7-4393db534542"
    },
    {
      "label": "741",
      "value": "4af11ed6-196d-4af8-9c83-46b63fe45683"
    },
    {
      "label": "756",
      "value": "8b3ca158-39c8-4074-be45-77a5ff7f6e06"
    },
    {
      "label": "7886",
      "value": "83d5590d-3029-49c0-9695-a4390a90455e"
    },
    {
      "label": "7887",
      "value": "90fa454b-f2f6-46a0-8792-6876a0f579e0"
    }
  ],
  "35ba130d-8056-4043-9fd1-7e9173b83aef": [
    {
      "label": "5580",
      "value": "8f72a2a1-c0fa-48a4-8ffd-95b13aa99bca"
    },
    {
      "label": "5581",
      "value": "85236b00-e70e-4f49-8c96-d36e562a6db0"
    },
    {
      "label": "5582",
      "value": "e1cd42b8-aa41-4b85-8f38-23a4ecd1ed1c"
    },
    {
      "label": "5583",
      "value": "e279f544-3ec0-4861-8cb6-cd76d5e7fd89"
    }
  ],
  "32c354a3-00e5-45db-a745-5473fece7c7e": [
    {
      "label": "9745",
      "value": "d710e6d6-f117-4347-a151-c3b81b9a7050"
    },
    {
      "label": "9746",
      "value": "43ad5279-c304-4a1b-b9d8-54e77a0b6f00"
    },
    {
      "label": "9747",
      "value": "525bdd29-da23-4d2e-a31b-12e49670eb27"
    },
    {
      "label": "9748",
      "value": "9d5961a3-66b9-4381-b8e8-d9395d2f30b2"
    }
  ],
  "eec8c7fc-458c-4916-8525-412e86a74ab2": [
    {
      "label": "101",
      "value": "160e66a4-be36-4600-bf85-d8edc1bbea95"
    },
    {
      "label": "102",
      "value": "7ecfa368-b621-4a81-962b-8b6e063da877"
    },
    {
      "label": "301",
      "value": "bc2e627f-4630-4ab9-9184-4ebdae4b5854"
    },
    {
      "label": "302",
      "value": "9d7020e1-2f5c-403d-8c2b-6b7c0027926a"
    },
    {
      "label": "401",
      "value": "3a319804-58b7-4539-b8de-4142c4020122"
    },
    {
      "label": "402",
      "value": "aedbc237-3c6f-41ae-b272-6063e9aaa745"
    },
    {
      "label": "801",
      "value": "c4431f26-fc19-49b3-a6a6-49d857c24dc8"
    },
    {
      "label": "802",
      "value": "4fd09d05-5ff4-4496-814e-2e109dda7955"
    }
  ],
  "a7e75b9e-d41f-4184-95d2-fd4b8809cc98": [
    {
      "label": "6291",
      "value": "cf1bcc31-9d66-467b-9054-45b64536a1fe"
    },
    {
      "label": "6296",
      "value": "2071315a-76bc-4382-9811-2f62ce3263df"
    }
  ],
  "2978937e-d383-47de-bed0-b54a432821b9": [
    {
      "label": "5595",
      "value": "06a5af01-193f-4b1c-8bce-02513586a9dd"
    },
    {
      "label": "5596",
      "value": "c434042c-1ee7-4dfc-8d8f-660987fca041"
    },
    {
      "label": "5597",
      "value": "5774ceef-0eeb-4756-bd80-e12d504ba8cd"
    },
    {
      "label": "5598",
      "value": "70d05286-5ca1-476d-a376-ae342c61849d"
    }
  ],
  "8e89f651-3871-42f7-85b1-5a9d3408397d": [
    {
      "label": "50",
      "value": "bed74b04-7e81-4bf7-960f-d315b2174736"
    },
    {
      "label": "51",
      "value": "b950dd3f-54e4-4747-a57e-705bcd60c3d7"
    }
  ],
  "d8e795d8-a1d9-457f-a31c-ed6bb74a92bc": [
    {
      "label": "7101",
      "value": "8804b96e-1f2b-41f7-b89f-c0425436afea"
    },
    {
      "label": "7102",
      "value": "49b75fd5-d9e0-4c6d-898c-c8f278604637"
    }
  ],
  "9b9e09dc-c213-47f4-a27a-b645e06acd6c": [],
  "b3960f91-c442-4056-bedf-a8d5524df21c": [
    {
      "label": "(4Z) 70",
      "value": "e05de992-2d51-421f-b35a-e9663fe9e0d4"
    },
    {
      "label": "70",
      "value": "56aeeba0-7ef2-414a-b11d-e14aa2cebe65"
    },
    {
      "label": "71",
      "value": "e83d85ba-1a7a-4b07-a0ad-6b6f90d736c2"
    }
  ],
  "540592d0-6ed0-43c5-9d63-e430c29aaa97": [
    {
      "label": "200",
      "value": "4cc9310d-4722-47d6-9aa4-0081b49e9ec0"
    },
    {
      "label": "201",
      "value": "35e402aa-88a7-45f3-b38e-38c6a8d9af4b"
    },
    {
      "label": "202",
      "value": "058c1343-0dfe-40c0-b7ef-16903df0df21"
    },
    {
      "label": "203",
      "value": "0cac9275-a8d9-4372-8c78-c4e162d69327"
    },
    {
      "label": "204",
      "value": "8785baea-eda8-4b78-82a3-89a051e3d077"
    },
    {
      "label": "205",
      "value": "39584191-4df4-4823-8ed6-92fa88d0539e"
    },
    {
      "label": "210",
      "value": "2f5964a7-fddd-4279-a7c8-a335545736a5"
    },
    {
      "label": "211",
      "value": "0230c16f-fc59-4532-a623-a176ec115425"
    },
    {
      "label": "220",
      "value": "440419c5-9b53-451f-abc8-7b0688f7f51f"
    },
    {
      "label": "221",
      "value": "4d2bb2e7-6408-4d69-ba6f-ec7212bb6f9d"
    },
    {
      "label": "230",
      "value": "8d5ec8c8-e052-4b35-a2f1-757b92753b3d"
    },
    {
      "label": "231",
      "value": "2ba2776e-e0d4-4d22-8542-93752a7414d4"
    },
    {
      "label": "244",
      "value": "7d48eb8c-75a9-4cc6-acb1-7887c79a83a4"
    },
    {
      "label": "245",
      "value": "c04e4ed8-6e03-4292-b0ea-40790b8a5b8e"
    },
    {
      "label": "QR1335",
      "value": "52e5e488-70bd-4250-9845-a0ab23aeb749"
    },
    {
      "label": "QR1336",
      "value": "65f7b09e-b17c-4e32-9f92-3190a80659aa"
    },
    {
      "label": "QR1341",
      "value": "47974149-48ab-4b25-951f-0083764ec053"
    },
    {
      "label": "QR1342",
      "value": "c5a3fe2e-c988-4d2e-b6a4-5d597cfc0777"
    }
  ],
  "76ff0f4d-4d31-4c47-b6fb-9d426b426d12": [
    {
      "label": "8540",
      "value": "ea15723a-b8fa-425a-8bc6-2626ba7bc8f5"
    },
    {
      "label": "8541",
      "value": "1550002a-0e5a-486f-bb57-006628d3ab3e"
    },
    {
      "label": "8554",
      "value": "b3a08588-35a1-4667-a697-4bbf5446e35f"
    },
    {
      "label": "8555",
      "value": "160baef5-0e4c-4178-b72c-994bf5ac0b2a"
    },
    {
      "label": "8600",
      "value": "2df8fbc7-a4eb-41b8-b0f2-e7aeb8090947"
    },
    {
      "label": "8601",
      "value": "b28370a3-6596-44b2-a8b3-509e771062eb"
    },
    {
      "label": "8602",
      "value": "1d2fa648-9abb-4084-b7c0-0543c607617b"
    },
    {
      "label": "8603",
      "value": "f95df088-5fe0-4d40-b035-9e9c99cc9886"
    },
    {
      "label": "8604",
      "value": "f74f4a37-2287-42b2-9b42-d8e0d95105eb"
    },
    {
      "label": "8605",
      "value": "dd60026f-e862-4c82-8689-b3aeb0362500"
    },
    {
      "label": "8606",
      "value": "3823eb77-cdae-4856-9df1-6f54f80682ab"
    },
    {
      "label": "8607",
      "value": "f37a4904-9061-499f-935f-c2860d3ad86d"
    },
    {
      "label": "8608",
      "value": "7b849f88-3d97-4a3a-ae7f-d35c093f3fed"
    },
    {
      "label": "8609",
      "value": "07f4a708-45fb-4d83-89fd-0463a0e78603"
    },
    {
      "label": "8640",
      "value": "bb501ef0-b865-46d8-83fe-8b5ab13ef09e"
    },
    {
      "label": "8641",
      "value": "daf20dff-c27a-4d7d-bcf9-6666d99c34b7"
    },
    {
      "label": "8642",
      "value": "8bfe518d-153d-4c33-9630-5051b6ebd472"
    },
    {
      "label": "8643",
      "value": "a7b94e61-e386-4d6b-8971-dbe026c85407"
    },
    {
      "label": "8644",
      "value": "c4397ec1-51e0-4128-b529-4261bdcd7991"
    },
    {
      "label": "8645",
      "value": "5b61304d-7939-4416-9707-e26ba764bb8a"
    },
    {
      "label": "8646",
      "value": "e681ab81-bcf3-4bf7-acbf-5a32191f54d4"
    },
    {
      "label": "8647",
      "value": "dd96fd47-ae96-430b-8006-7c3dee399fd7"
    },
    {
      "label": "8648",
      "value": "c7afd751-5088-4c2b-b622-3345864e08a0"
    },
    {
      "label": "8650",
      "value": "db2972d5-7cf6-4f26-a02a-6839aafea884"
    },
    {
      "label": "8651",
      "value": "5a943c6b-b402-4842-8d27-52b1e311ca7e"
    },
    {
      "label": "8652",
      "value": "15603370-249a-49fa-a6db-8f18d7819292"
    },
    {
      "label": "8653",
      "value": "7393ebd6-a503-408e-8848-434da5ae276d"
    },
    {
      "label": "8654",
      "value": "1cafc2fb-b9e9-494c-9a77-26cc594ae126"
    },
    {
      "label": "8655",
      "value": "14d31baa-7eb3-4975-bc20-fa819d3988ad"
    },
    {
      "label": "8656",
      "value": "9cccc33c-9dbb-4224-87fc-712684f77599"
    },
    {
      "label": "8657",
      "value": "0d9122c0-7393-41c6-bf7e-fd941b3254cb"
    },
    {
      "label": "8658",
      "value": "067b09cc-3a76-4971-a7c8-c8ad808d5bc9"
    },
    {
      "label": "8659",
      "value": "667096d2-2baf-42ab-b725-f2db05bc948d"
    },
    {
      "label": "8660",
      "value": "f55acf8a-ac1f-4cef-8fed-8a91fd29e4c8"
    },
    {
      "label": "8661",
      "value": "0b90943a-d2b3-458e-8d0d-f7259f72ade4"
    },
    {
      "label": "8662",
      "value": "397c7ba5-9071-4000-b9ad-3fe6e8177064"
    },
    {
      "label": "8663",
      "value": "95d94229-0c49-429b-bacc-c355f95933e3"
    },
    {
      "label": "8664",
      "value": "5446c427-682b-4825-8ed0-780085543336"
    },
    {
      "label": "8665",
      "value": "9036d337-714f-44fb-9fa1-b3f4653257b2"
    },
    {
      "label": "8666",
      "value": "5d1e9d74-8ed4-4df8-af3e-51b2502ecd3d"
    },
    {
      "label": "8667",
      "value": "9602b6aa-07a9-4931-9236-b78218d81584"
    },
    {
      "label": "8668",
      "value": "b0b970e3-f9d9-4709-9e05-076bfd0ed0e3"
    },
    {
      "label": "8669",
      "value": "d7d2dc57-2dc0-47ca-955c-3af19b22322c"
    },
    {
      "label": "8678",
      "value": "19726429-90ed-4ba5-96af-221d4a51c59c"
    },
    {
      "label": "8679",
      "value": "497b5f08-2d26-4712-8296-c733c69309bc"
    },
    {
      "label": "8684",
      "value": "da15f672-d202-4c85-bc79-06559ae89e23"
    },
    {
      "label": "8685",
      "value": "6b5c0909-9a77-4dab-a567-65775fb06829"
    },
    {
      "label": "8690",
      "value": "0081d3e1-24c7-4a14-abee-fe4ebd6a9f3c"
    },
    {
      "label": "8691",
      "value": "991ca3db-3209-4c52-a537-f50f2312d692"
    },
    {
      "label": "8692",
      "value": "e5609ea0-4d8c-4d20-8ae6-26ac3a5701b8"
    },
    {
      "label": "8693",
      "value": "9791aa9d-f15b-493e-8f54-dfb9a0700211"
    },
    {
      "label": "8694",
      "value": "80caf608-265c-4a56-b5cf-b7d54da60271"
    },
    {
      "label": "8695",
      "value": "d031580f-9fa2-4421-b4f8-0541aa9a4630"
    },
    {
      "label": "8696",
      "value": "876a3dbb-c704-44a8-a108-834db0579a1d"
    },
    {
      "label": "8697",
      "value": "3db6efff-d3b4-4a6c-aa5d-dd5681d45b96"
    },
    {
      "label": "8700",
      "value": "fcd03f60-552d-48b4-9b5b-faead16a5e5c"
    },
    {
      "label": "8711",
      "value": "3e4bfa5d-4075-4986-8b03-ed7b7b94ae9e"
    },
    {
      "label": "8712",
      "value": "dd86a393-bba5-4da9-9a71-d07d5a910806"
    },
    {
      "label": "8713",
      "value": "2c8dc1db-fa17-4bc5-8f9a-b0de3f81efe4"
    },
    {
      "label": "8714",
      "value": "0851244b-55d2-438f-a531-c56e5e3614b8"
    },
    {
      "label": "8715",
      "value": "dabd1cf6-68b1-4426-addd-2513d32c05b7"
    },
    {
      "label": "8716",
      "value": "636efc68-c22f-4ed2-8325-250c9b2e7ccc"
    },
    {
      "label": "8717",
      "value": "da5734f3-4242-43ad-af11-c683f900077b"
    },
    {
      "label": "8718",
      "value": "7f2e5960-fda3-42f2-bbae-91cc0fa59b91"
    },
    {
      "label": "8719",
      "value": "75d2e763-0e80-4384-8cc6-af58fa024aeb"
    },
    {
      "label": "8720",
      "value": "f98452fb-5875-401e-a2d0-c9751fad34f4"
    }
  ],
  "c397d351-6dd2-4954-a2e4-31c7332d57eb": [
    {
      "label": "101",
      "value": "4bd27d71-7a3c-4541-ae9d-1b752ae09bd1"
    },
    {
      "label": "102",
      "value": "e595e4bb-d928-47b7-b877-17e2f1fd91b6"
    },
    {
      "label": "301",
      "value": "bc1356f6-6754-4a7b-b759-30590de41599"
    },
    {
      "label": "302",
      "value": "22543260-6a18-41b0-80a9-44cdf97476af"
    },
    {
      "label": "303",
      "value": "0f241e21-31f1-49bb-ae8d-bf857c7f3212"
    },
    {
      "label": "310",
      "value": "304a3c48-5f63-4240-a5f5-c3eaa591bd2e"
    },
    {
      "label": "311",
      "value": "bf6389a4-cd7b-4cd0-8aca-4af26946f260"
    },
    {
      "label": "401",
      "value": "385de760-b0d5-4d13-9297-994087f4b46f"
    },
    {
      "label": "402",
      "value": "dd10b03d-6665-4adf-a2fb-d131841923af"
    },
    {
      "label": "602",
      "value": "bec1cc9f-aa14-4844-afb3-e13a6062f5a0"
    },
    {
      "label": "801",
      "value": "02beb9b2-7ecf-4ac2-bbd5-48aecb2fbc1b"
    },
    {
      "label": "802",
      "value": "7b728e55-fb58-49a1-a661-6b8d4c0a32b5"
    }
  ],
  "55b6f9e1-7ea1-4655-8ba8-1731411a59d4": [
    {
      "label": "1044",
      "value": "83d63f1c-1df5-4e54-82a9-dd879035086c"
    },
    {
      "label": "1045",
      "value": "5a68289c-42ea-4273-a9a9-c6a53160280c"
    },
    {
      "label": "308",
      "value": "7f020b0a-4869-405a-aa73-ffff1ab8c8a0"
    },
    {
      "label": "309",
      "value": "be6ad07d-cf1e-4490-bc6c-07b9320e09eb"
    },
    {
      "label": "318",
      "value": "78fb38c6-d201-4b14-8fe9-fed2af69a7e0"
    },
    {
      "label": "319",
      "value": "2a599dd1-de96-459e-9a19-f0c3f7a78328"
    },
    {
      "label": "322",
      "value": "7b4ad7a4-d4a9-4541-9149-4865cb8c5483"
    },
    {
      "label": "323",
      "value": "684ddecd-f866-4900-8bc1-619f95ee7ad0"
    },
    {
      "label": "324",
      "value": "e33369ff-74a5-43dc-aac7-c70b3bc17620"
    },
    {
      "label": "325",
      "value": "94ca7445-c207-4d40-8cec-e841d649c2f6"
    },
    {
      "label": "3305",
      "value": "c840696d-9f49-4433-8fc2-4d053bc37ce0"
    },
    {
      "label": "3613",
      "value": "44389b04-adf6-4fbf-a77d-4ece208c9715"
    },
    {
      "label": "50",
      "value": "25057b20-f39f-42cb-98e2-049a22ecf80b"
    },
    {
      "label": "51",
      "value": "dd26b5fb-42d4-47ba-a66e-1beab80c0b25"
    }
  ],
  "54c6edc0-a8a6-442c-967c-aa29daae4b5c": [
    {
      "label": "7913",
      "value": "df9eaf97-8c0e-41f6-ad8f-fe3b5fec6d66"
    },
    {
      "label": "7914",
      "value": "6226a872-33b9-442e-8961-f3cec5aadf70"
    },
    {
      "label": "7917",
      "value": "84a26d4f-497f-44fb-8291-c99e5fda320f"
    },
    {
      "label": "7920",
      "value": "25c2bc56-f6cb-446b-9751-1d766eca6eac"
    },
    {
      "label": "7921",
      "value": "d19ca8c5-1ef8-495a-9ec2-51dadd742d25"
    },
    {
      "label": "7922",
      "value": "b7231b42-805a-4de8-b948-0e726a4ae22b"
    },
    {
      "label": "7923",
      "value": "2420bb81-5af4-4ca4-8096-a02b16c642fb"
    },
    {
      "label": "7924",
      "value": "11a64a26-3c75-432a-addd-6f337d0647ef"
    },
    {
      "label": "7929",
      "value": "2b0fb204-d8d6-4408-a5f9-97af3eb7843a"
    },
    {
      "label": "7931",
      "value": "a719dbad-f7f8-4063-b881-696f90684150"
    },
    {
      "label": "7987",
      "value": "d2c1800e-318d-47f8-b8d1-9def6e72458f"
    },
    {
      "label": "7988",
      "value": "f45d6d3f-6a85-43dc-8a07-bfaa86de0503"
    }
  ],
  "d73f3966-631e-445d-84d7-08a5c9b44170": [
    {
      "label": "GF0707",
      "value": "f78b764d-485a-498a-9626-0e9e9b79241c"
    },
    {
      "label": "GF0708",
      "value": "668db6aa-6b00-4bd7-9fce-962c4a5abab9"
    },
    {
      "label": "GF0709",
      "value": "31e7a463-4d73-4d09-9983-ed9b8ab38d02"
    },
    {
      "label": "GF0710",
      "value": "c87104f8-add9-4247-81a5-3e794ff41906"
    }
  ],
  "2bb1d0a8-0bd2-4d54-97f3-d997850bae0b": [
    {
      "label": "4118",
      "value": "40ae21aa-d3d0-48b6-b356-ca370e0eb582"
    },
    {
      "label": "5626",
      "value": "510d5605-1fd7-4189-bd92-19b96f953f3d"
    },
    {
      "label": "5627",
      "value": "00212f58-64b0-483a-b38c-8a203930e2b9"
    },
    {
      "label": "7632",
      "value": "2973f981-5ffd-41bb-ab27-5ab7b1280ddc"
    },
    {
      "label": "7633",
      "value": "230d0c52-e830-41a8-bace-3436ad3d5f2c"
    },
    {
      "label": "7640",
      "value": "10cdb448-98ed-4a53-af2a-a039ed6e3c6d"
    },
    {
      "label": "7641",
      "value": "acb9434e-cc4b-4852-9e8c-db32c0f6105f"
    }
  ],
  "7b4fccfc-3543-45ac-a32b-95a22cde7680": [
    {
      "label": "2282",
      "value": "92181240-33b3-45a9-9a9a-8f78556a52c2"
    },
    {
      "label": "2283",
      "value": "d6eec28e-0920-4c4a-afb8-c611182f051b"
    }
  ],
  "960b6b40-06b4-4e4b-9151-1fa4b6ee2538": [
    {
      "label": "5353",
      "value": "f423344c-4adf-4427-ba0d-219733ffb4b4"
    },
    {
      "label": "5354",
      "value": "7750d0dc-8202-43be-bc2b-b2163169c1f6"
    },
    {
      "label": "5669",
      "value": "44a1271a-68c8-47f7-8606-19475ff1f605"
    },
    {
      "label": "5670",
      "value": "be99f91b-06bc-4e7b-b3f3-b09e8f2ed871"
    },
    {
      "label": "7039",
      "value": "1297d6b7-d286-4638-a1bb-44e7a845c801"
    },
    {
      "label": "7040",
      "value": "56990b53-66f2-40e1-ab91-6b1d57b67948"
    }
  ],
  "9cf6a3f5-6588-49b2-a6dd-9257124cfd26": [
    {
      "label": "300",
      "value": "6a951a4a-f55d-4ee2-b93c-8f1f1c4f9edf"
    },
    {
      "label": "301",
      "value": "607acce6-dd7c-4e1f-bffd-e0d47e61d9fc"
    },
    {
      "label": "9300",
      "value": "fc2a4f6d-224e-4502-b67e-6a652207b333"
    }
  ],
  "0388c681-2d0e-494a-b9e4-ebc1cf6ce7b7": [
    {
      "label": "6321",
      "value": "9d46cc57-532b-45b9-a4c4-9da0764d6cf4"
    },
    {
      "label": "6358",
      "value": "987415ce-6858-4381-97d6-8e86aa0d52a1"
    },
    {
      "label": "7380",
      "value": "dee091eb-9723-4406-8cae-535b7b507aa4"
    },
    {
      "label": "7382",
      "value": "90da5899-70d2-47b6-b130-074b3caf3dc8"
    },
    {
      "label": "7383",
      "value": "043a394d-66f0-441e-80c2-7666412a8d41"
    },
    {
      "label": "7390",
      "value": "b618914f-94f7-44b8-8615-cce3a7bbef37"
    },
    {
      "label": "9610",
      "value": "99c599cb-e61c-4a59-a3a8-59017d84d31b"
    },
    {
      "label": "9611",
      "value": "cb1c81a5-db27-4775-9e01-9e202969b243"
    }
  ],
  "82f2c731-308a-4c2e-b846-ee60871fe62e": [
    {
      "label": "7530",
      "value": "bf5c6e4b-be9d-446d-a6a8-7fc082b6e14a"
    },
    {
      "label": "7531",
      "value": "088a66e6-42a9-4db9-8e77-2b36625926af"
    },
    {
      "label": "7532",
      "value": "0d9f4631-0d82-4943-9eed-52ec0b0970d6"
    },
    {
      "label": "7533",
      "value": "10cb31b4-5563-47d5-aa3e-25bc1c2e73a8"
    },
    {
      "label": "7534",
      "value": "0af34a2c-3f53-4900-bd38-6c2bf134c6c6"
    },
    {
      "label": "7535",
      "value": "e61e5e93-877c-4aaa-8794-0df1b193526e"
    },
    {
      "label": "7536",
      "value": "79271fb3-e76e-494e-8e79-021ffccbd379"
    },
    {
      "label": "7537",
      "value": "96191953-517e-489d-922e-799ec4e9baec"
    },
    {
      "label": "7538",
      "value": "5d37e998-d502-454e-9c82-f07cb6b5a609"
    },
    {
      "label": "7539",
      "value": "d3c50a33-0d02-4e88-8769-c299f53bc1b7"
    },
    {
      "label": "7540",
      "value": "0e4f0e0d-12b1-430f-a66e-8ee36bb7bd37"
    },
    {
      "label": "7541",
      "value": "a4bd22e1-63b1-4234-aace-25e2eb0380b2"
    },
    {
      "label": "7542",
      "value": "800ef0fa-374d-4cfe-9613-c4c5d3ad28df"
    },
    {
      "label": "7544",
      "value": "acc7404d-5962-47f1-8ebd-51c8421500a8"
    },
    {
      "label": "7545",
      "value": "447c693e-bd5d-4214-bf1e-5ad0cabc7afd"
    },
    {
      "label": "7546",
      "value": "e20fa226-e692-42df-bf07-4c77da2e9bea"
    },
    {
      "label": "7548",
      "value": "74037cb9-47b3-4c00-808e-71d9868e000d"
    },
    {
      "label": "7551",
      "value": "8d9464e8-7c18-46a7-a8f4-32be6500b4cd"
    },
    {
      "label": "7552",
      "value": "2e67423b-4ff7-44d7-9c5c-6481802e5c2e"
    },
    {
      "label": "7553",
      "value": "00eb4fd2-7fc3-4f93-8a40-90dcb802222c"
    },
    {
      "label": "7555",
      "value": "3e710cbf-27eb-4d2d-a02f-a1fa6ddab716"
    },
    {
      "label": "7556",
      "value": "194c360c-53c2-4bf1-9e2a-2c5687498bf6"
    },
    {
      "label": "7557",
      "value": "e6fd127e-33d7-4a8f-a2c9-ad4138ea5f54"
    },
    {
      "label": "7558",
      "value": "40eb7a84-6f60-44b4-81e2-a0373043a174"
    },
    {
      "label": "7559",
      "value": "9246c712-4971-4a6d-8de6-8eef5f22920b"
    },
    {
      "label": "7560",
      "value": "985265de-e7dd-4cfb-8ce7-c79b7fd7bf46"
    },
    {
      "label": "7561",
      "value": "ed6b3130-b3a2-48dc-bd0a-24a331b9a976"
    },
    {
      "label": "7562",
      "value": "b92e3645-abf4-4dda-97ab-ccecfa6732d2"
    },
    {
      "label": "7563",
      "value": "3a9dffed-010d-43e1-a6a9-67de55b9da14"
    },
    {
      "label": "7564",
      "value": "96fcb950-15ba-426f-8947-b2d341e8f902"
    },
    {
      "label": "7565",
      "value": "1bffad33-e893-43e0-a09f-1c69855f9b30"
    },
    {
      "label": "7566",
      "value": "d3c514a4-de5e-448a-9960-1b3125946890"
    },
    {
      "label": "7567",
      "value": "1dfe9001-c40e-47e8-a33d-7c70aa5f4ea1"
    },
    {
      "label": "7568",
      "value": "fa4e86bc-1059-49af-95bc-f1ad6aba8e12"
    },
    {
      "label": "7569",
      "value": "9dfa3f0e-82e5-448e-b9a3-dc250159323d"
    },
    {
      "label": "7571",
      "value": "1a66bdd9-bc07-438d-bb2e-0306a5703610"
    },
    {
      "label": "7572",
      "value": "a23f5537-f7aa-4c01-842f-47b512b4334d"
    },
    {
      "label": "7573",
      "value": "3c10b343-6d1e-4c5e-8ec8-8f074d908435"
    },
    {
      "label": "7574",
      "value": "9e5d9e71-3be7-434e-928c-9fe9f80feab7"
    },
    {
      "label": "7575",
      "value": "7d17e0b1-3a1c-4cfb-889e-66532a83a193"
    },
    {
      "label": "7576",
      "value": "e3e90194-f99b-41b3-970b-4e2ea22f89c4"
    },
    {
      "label": "7577",
      "value": "03914b72-40de-4885-a8fa-b2d5e56a30c2"
    },
    {
      "label": "7579",
      "value": "5f19089f-d6cb-4419-aa06-d63319f8e60e"
    },
    {
      "label": "8192",
      "value": "35b4e6ca-da7f-4eef-8eee-ba5df4ed3fea"
    },
    {
      "label": "8208",
      "value": "f28a9627-c063-455d-90e3-b20bec54c6e6"
    },
    {
      "label": "9323",
      "value": "74e69b89-c64c-49e1-8344-c69830722bc9"
    },
    {
      "label": "9329",
      "value": "db016edc-d804-4219-9551-b763704c98c3"
    },
    {
      "label": "9388",
      "value": "c7ec42b9-7b27-43dc-81d5-890e9ea79612"
    },
    {
      "label": "9389",
      "value": "4a3e18e0-f99c-4901-b92d-9e591897d013"
    },
    {
      "label": "9391",
      "value": "7baca24c-4b5d-42d5-bebc-b2c90404dbb9"
    },
    {
      "label": "9520",
      "value": "5a05de97-7eb7-43ad-9f7d-27e9eb8481d7"
    },
    {
      "label": "9638",
      "value": "64dcfd77-20dd-46d8-a8e7-da95e6406ac1"
    }
  ],
  "d8b645a9-2c5d-480c-8f6e-3156e53112c4": [
    {
      "label": "134",
      "value": "2459b1c3-5f54-4aa7-b29c-bf7dc7fc8ae6"
    },
    {
      "label": "135",
      "value": "933c95aa-b535-4e4d-b22a-dc8016c26ecb"
    },
    {
      "label": "136",
      "value": "2ee07862-e89e-40e4-9bce-2f9e7aefaf4b"
    },
    {
      "label": "137",
      "value": "fe9c367a-ad01-43e0-8f19-1331303c19cc"
    },
    {
      "label": "140",
      "value": "45387a6c-5634-4bdc-af21-e732414e61dc"
    },
    {
      "label": "144",
      "value": "d0e28b86-4ea3-472c-b0dc-7c9dab5f9bf9"
    },
    {
      "label": "145",
      "value": "b63aeab9-4a18-42a8-b9b9-c1b012a60e5f"
    }
  ],
  "4794abfc-d9e1-471e-b898-4bbdcd8bf5f5": [
    {
      "label": "5844",
      "value": "abad8d32-ea2d-4734-8420-497d5af4e27a"
    },
    {
      "label": "5845",
      "value": "7031a79e-c6ca-48ac-bf67-1489ef583483"
    },
    {
      "label": "5846",
      "value": "99ed667b-a3fd-41d9-809a-c33e5c9e4a1a"
    },
    {
      "label": "5847",
      "value": "81c378fd-9aa5-4e53-a943-6f109dba9615"
    }
  ],
  "ef88a5af-818f-43ac-a9a7-70f228de96a9": [
    {
      "label": "11",
      "value": "a5d4c08d-840e-4d71-bb15-23a58c94de50"
    },
    {
      "label": "12",
      "value": "f69b1fdd-918b-41b1-baf7-858a6eb3a056"
    },
    {
      "label": "2",
      "value": "3886134e-44e6-447d-8d5d-284c394311d5"
    },
    {
      "label": "2071",
      "value": "4d4e7040-a5c3-437a-8c63-f8ff3dfcb283"
    },
    {
      "label": "2072",
      "value": "5151142b-8045-467b-9912-4699de9399f8"
    },
    {
      "label": "2075",
      "value": "a52f4be7-1401-4984-bb30-ddda7329dbb7"
    },
    {
      "label": "2076",
      "value": "d59977fd-a012-4b9d-a78c-7b9a47dff755"
    },
    {
      "label": "2077",
      "value": "03c2005b-f720-49cb-a23a-ade59e5ba532"
    },
    {
      "label": "2078",
      "value": "7a85d106-b691-4e6d-9c32-66b553cc5445"
    },
    {
      "label": "2081",
      "value": "a88ef225-8e06-4ee2-9383-4bf780d5b4b2"
    },
    {
      "label": "2082",
      "value": "1b763b1d-d3ee-438e-9289-51ce9a5c8c84"
    },
    {
      "label": "2083",
      "value": "11050a9c-6b6b-459b-86a5-ee04076f341f"
    },
    {
      "label": "2084",
      "value": "a90ccb21-82e5-40cf-9b4f-c96cb7553d1a"
    },
    {
      "label": "2085",
      "value": "e1ce8fa6-c942-4e0f-8abc-539053b396ef"
    },
    {
      "label": "2086",
      "value": "77106f97-c31c-435e-b0d0-211e0dc300e4"
    },
    {
      "label": "21",
      "value": "aee9c586-aa61-40c1-8a2a-7391f4531738"
    },
    {
      "label": "2111",
      "value": "cff5cac0-13f1-413d-80f0-d420707a3fca"
    },
    {
      "label": "2112",
      "value": "d3752202-605b-4edb-b9c7-be132a1e310b"
    },
    {
      "label": "2119",
      "value": "5e334bdf-7ed8-42a4-a81b-2ba98636917c"
    },
    {
      "label": "2120",
      "value": "8c15fdb2-cc23-40f9-8b50-99a4a3bdae49"
    },
    {
      "label": "24",
      "value": "de348e74-246e-4eb3-923a-f6eb55f9be60"
    },
    {
      "label": "2405",
      "value": "4ecd08a7-303c-44c4-8cdc-65e469b16262"
    },
    {
      "label": "2406",
      "value": "b6c5d4f2-6d02-427a-9ae3-0f965d611ea1"
    },
    {
      "label": "241",
      "value": "6d046ce7-5eda-49a2-b88b-f8689a2ef6e4"
    },
    {
      "label": "242",
      "value": "7403fb11-a9f9-4b1d-b2a1-bd77e1937636"
    },
    {
      "label": "244",
      "value": "f676833f-793d-4035-9d45-2299925751f2"
    },
    {
      "label": "248",
      "value": "ecc99908-0dab-4bda-84c3-e518414ebdf8"
    },
    {
      "label": "25",
      "value": "abaaa9e2-ba31-414f-8460-4486a3f10850"
    },
    {
      "label": "5",
      "value": "17e8df34-d553-4a00-8d33-fefebcca53e4"
    }
  ],
  "0b428433-1712-4658-abd2-21ff08dd9342": [
    {
      "label": "1853",
      "value": "a12c2446-d7a4-4fb6-a34a-c42d797e5177"
    },
    {
      "label": "1854",
      "value": "ff25a51c-5239-4aee-ad33-48e715301ccd"
    }
  ],
  "b684a080-f079-44e1-87b0-96e9ec13e6e6": [
    {
      "label": "2431",
      "value": "460c98a2-c39d-4264-9e02-a25090c29e63"
    },
    {
      "label": "3516",
      "value": "28e9ea9c-e04c-4cd0-af58-1067610f2581"
    },
    {
      "label": "3517",
      "value": "decbd53b-0049-4d54-81f0-cde035fe32db"
    },
    {
      "label": "6178",
      "value": "6321f618-47ba-4534-8b45-16c5da4ff697"
    },
    {
      "label": "6296",
      "value": "f5784ee3-708f-4c0d-9ec0-e5008068a4b0"
    },
    {
      "label": "6298",
      "value": "5dc266a7-bf98-4d76-91ed-a20f9dc23893"
    },
    {
      "label": "6299",
      "value": "b05dc307-b442-40fa-9b3b-d50191cfbcb6"
    },
    {
      "label": "7322",
      "value": "13a3ce61-6743-4180-9325-9fa63284b312"
    },
    {
      "label": "7978",
      "value": "5c637aff-bae7-442d-afce-169f4de4d12e"
    },
    {
      "label": "7980",
      "value": "fd69abfd-322b-40e3-9e9e-31d6ffdd5a0b"
    },
    {
      "label": "7981",
      "value": "42f6b547-7a70-4bed-9d69-2fb7cc426cc3"
    }
  ],
  "c96cca58-de82-458f-a8c1-85d3068a3e02": [
    {
      "label": "101",
      "value": "0fb10e6b-693e-417c-953e-70b1fd498a57"
    },
    {
      "label": "103",
      "value": "6da9a500-b56f-4537-a996-b76281b7ff8f"
    },
    {
      "label": "104",
      "value": "3af5da87-fd87-4934-ad6a-2efb63d5cbd9"
    },
    {
      "label": "107",
      "value": "e672f43a-fded-46e4-aafb-0d765cc510b0"
    },
    {
      "label": "110",
      "value": "9c7363ab-613e-42be-958c-b17782fcceb9"
    },
    {
      "label": "113",
      "value": "83a228ca-f6f5-4c7a-8652-ac71620a0d09"
    },
    {
      "label": "121",
      "value": "5d50f057-4872-4cc8-8fb9-f340042c0d92"
    },
    {
      "label": "131",
      "value": "df827b12-e744-4929-8555-c6a9113b46fd"
    },
    {
      "label": "144",
      "value": "f3636a43-63e7-43c6-841f-e3b0cda43ded"
    },
    {
      "label": "145",
      "value": "64d717b9-76e9-4c93-bfd1-59ab09bff712"
    },
    {
      "label": "210",
      "value": "58b3c435-e823-485a-9875-56dee3c971c6"
    },
    {
      "label": "226",
      "value": "7a897751-7f45-4cd8-9cac-14c59730e68f"
    },
    {
      "label": "402",
      "value": "87774d4f-a364-4983-97e6-8a5176da6841"
    },
    {
      "label": "456",
      "value": "e59ee707-37cf-45ae-bbfe-29da015c6911"
    }
  ],
  "08c20266-138d-422e-913d-b846a6afd813": [
    {
      "label": "6654",
      "value": "6feb8b2e-7cd4-48ff-9e78-0285e2d0e74a"
    },
    {
      "label": "8201",
      "value": "31a0d416-712f-425e-9d0f-61cf5a73da8b"
    },
    {
      "label": "8202",
      "value": "8b4a244b-7cc1-461c-b542-4852474c0f9f"
    },
    {
      "label": "8227",
      "value": "e41624db-3dda-4650-8abe-ab1b396895ce"
    },
    {
      "label": "8228",
      "value": "ecd8cb3c-b811-480e-a1a8-1e94fe67bb6e"
    }
  ],
  "ca53e464-6646-42c8-a8ba-44cdb309c68c": [
    {
      "label": "9708",
      "value": "211b75c5-d9e5-4510-8a26-3bed08b4280c"
    },
    {
      "label": "9709",
      "value": "7b4f9fa0-a96a-4e7f-b3fd-c05ab5efd33c"
    },
    {
      "label": "9734",
      "value": "4d328618-27e6-4d67-b075-8354b9bad4b4"
    },
    {
      "label": "9735",
      "value": "5f74f27d-a953-41b9-a377-72833523b152"
    }
  ],
  "a4865a71-e8ff-41b8-99a6-1d7c53a47b20": [
    {
      "label": "1289",
      "value": "de480603-c3ad-49a6-93fa-6b00640021b0"
    },
    {
      "label": "1290",
      "value": "85b8cf77-fc61-482d-b60f-2f9241af6e27"
    }
  ],
  "2eb6491e-5072-4437-b425-033d3b97c14c": [
    {
      "label": "1006",
      "value": "4161a186-7068-43c7-b9a5-56c61860b188"
    },
    {
      "label": "1007",
      "value": "9afa42bb-f2e5-46f3-b351-27b314225d18"
    },
    {
      "label": "1010",
      "value": "d9702b97-0ef8-4674-9403-8683cd6c1b26"
    },
    {
      "label": "1021",
      "value": "e37a384c-503c-4481-b4c7-5328d223912c"
    },
    {
      "label": "1039",
      "value": "f4bef023-d089-4665-a02e-9894dbc115c6"
    },
    {
      "label": "1040",
      "value": "20b3b61c-a1a9-4a52-8852-c18157e600c3"
    },
    {
      "label": "1041",
      "value": "14b75264-2074-41d3-a378-fbad51bf843e"
    },
    {
      "label": "1043",
      "value": "5606fb3a-caf0-4970-b57f-cd363fd9b055"
    },
    {
      "label": "78",
      "value": "cc27c12a-e953-467e-afcf-3b3fe3d43e98"
    },
    {
      "label": "79",
      "value": "602d2e60-7745-4383-80cc-1cf6b144da62"
    }
  ],
  "b10a0664-b037-4500-a2e2-63b85b783f76": [
    {
      "label": "KQ 108",
      "value": "f1bc56a0-ba6c-40e5-9b89-3ed9d2de6209"
    },
    {
      "label": "005",
      "value": "3401fcaa-69fc-45e0-b04e-2c4536e09d71"
    },
    {
      "label": "100",
      "value": "a05eea39-0f71-49cf-ba81-82c1457c5dbb"
    },
    {
      "label": "101",
      "value": "a5ec68ea-d627-4120-91e3-88a35bf1bb22"
    },
    {
      "label": "102",
      "value": "6166adf5-ccd4-417f-976a-f9b77df5155c"
    },
    {
      "label": "103",
      "value": "9f1c928b-966b-4368-ac74-9adaa61c5c35"
    },
    {
      "label": "108",
      "value": "c2ad8b48-0e9e-4c8e-93cd-d4a38fe235e3"
    },
    {
      "label": "11",
      "value": "8792002f-1171-4bb3-b67c-6278f42e68c8"
    },
    {
      "label": "112",
      "value": "5b0cdf59-f656-4b70-99c8-301356b3310e"
    },
    {
      "label": "113",
      "value": "d16fdfe7-ca19-4268-be79-d05a603444cf"
    },
    {
      "label": "115",
      "value": "af1b8ba6-1737-4d1f-a849-92bf449d73ca"
    },
    {
      "label": "116",
      "value": "709f2f98-502f-4e5d-9396-4716bb42d3b0"
    },
    {
      "label": "117",
      "value": "cdf443b8-fd40-43c0-bcea-114d1a90458e"
    },
    {
      "label": "2",
      "value": "a1dce36b-72a0-443e-bfa9-93b9754eea7d"
    },
    {
      "label": "202",
      "value": "10f29632-5441-496e-a97f-beddcecfb9c8"
    },
    {
      "label": "203",
      "value": "909759ba-7ab9-4019-b96e-087f17438be4"
    },
    {
      "label": "204",
      "value": "58737ac5-a5cc-4a6c-8f8c-baebb023e0e1"
    },
    {
      "label": "205",
      "value": "9e1a6b64-f94c-418b-a454-014370a68411"
    },
    {
      "label": "2412",
      "value": "9e2c7778-70e0-4bc3-a207-d2ffe53f1c89"
    },
    {
      "label": "2413",
      "value": "6a770b07-0c0e-44d0-ad27-f27d39b63aa2"
    },
    {
      "label": "2414",
      "value": "0278945b-4337-48b6-ba81-0b615ce5d1d9"
    },
    {
      "label": "2415",
      "value": "e1de9296-84c6-4592-bf5f-ba2b8606e167"
    },
    {
      "label": "2426",
      "value": "ec9e59ec-b7fd-4bf8-b248-22d1229e2889"
    },
    {
      "label": "2427",
      "value": "0c5bebaf-9353-493c-9e8c-176f14710da9"
    },
    {
      "label": "250",
      "value": "817e3016-403e-4d21-b97d-6c1be7538931"
    },
    {
      "label": "251",
      "value": "502500a9-1f45-4508-98fa-1c3d31d06024"
    },
    {
      "label": "2522",
      "value": "429aade3-11e9-4389-923e-a78c0e909f0d"
    },
    {
      "label": "2532",
      "value": "59fe98ee-f07e-47c7-88ee-e33937648291"
    },
    {
      "label": "2533",
      "value": "1d84c352-e9e7-43c8-866b-a57f0f924b3a"
    },
    {
      "label": "254",
      "value": "6a3df7d7-1a4d-4cf8-b4e7-c63959b55f8a"
    },
    {
      "label": "255",
      "value": "e76faba6-d01c-4b3f-accc-917a09b8149b"
    },
    {
      "label": "256",
      "value": "d7132e26-900c-4e58-81a7-751487ab9321"
    },
    {
      "label": "257",
      "value": "8ede3c41-cf49-43b1-9f6d-727d157a0586"
    },
    {
      "label": "258",
      "value": "445abe57-71be-45b4-a351-f3ae4d7d704f"
    },
    {
      "label": "2580",
      "value": "2a74bcc0-7a27-420d-a752-abd2c8b6deec"
    },
    {
      "label": "2581",
      "value": "8403bd46-9fb1-4dcf-80e4-4353fcddbdd7"
    },
    {
      "label": "259",
      "value": "ca86a818-a8e2-4f9a-a427-1b9ce80f1e26"
    },
    {
      "label": "262",
      "value": "0d56f92f-5dd6-400a-954f-015df2949938"
    },
    {
      "label": "263",
      "value": "1f1acccf-0520-4c59-ac17-9d6c8dbf9e87"
    },
    {
      "label": "264",
      "value": "0c92a115-8403-4057-a13f-ee87dba4396f"
    },
    {
      "label": "265",
      "value": "a91b0682-abbd-4d6b-bc0b-038fc85ca07d"
    },
    {
      "label": "266",
      "value": "b593fe46-dcfd-4d14-8449-fa7617fb3da8"
    },
    {
      "label": "267",
      "value": "fe22fd4b-2ad7-4901-a3ee-e78131d4796e"
    },
    {
      "label": "270",
      "value": "8a2b2cda-63fc-4fe2-9d36-947100ca840d"
    },
    {
      "label": "271",
      "value": "95af38d5-1961-40e3-8da6-63ead8ad1e20"
    },
    {
      "label": "2720",
      "value": "92a11cfc-42ac-443a-80c7-175735f7af8e"
    },
    {
      "label": "2726",
      "value": "f665eead-7594-4187-ae22-8c09f8e8d047"
    },
    {
      "label": "2727",
      "value": "9deaa8d0-94b0-4f63-a528-9920e6ffa711"
    },
    {
      "label": "274",
      "value": "763ab81e-f685-49c6-9560-31a89b2e60f2"
    },
    {
      "label": "2748",
      "value": "513f163d-6e2b-4e1d-abee-a402566270f8"
    },
    {
      "label": "275",
      "value": "c95078ad-ee8c-455a-b84c-80295ec65ad4"
    },
    {
      "label": "2765",
      "value": "2e6951db-a981-4ed8-8c33-5935766b56e9"
    },
    {
      "label": "2767",
      "value": "6a66b03d-df70-4453-8b4b-d7020a9d7c90"
    },
    {
      "label": "2774",
      "value": "670f986a-b6b9-4c7b-a6d4-6db4f473e5dc"
    },
    {
      "label": "2775",
      "value": "1760ddc5-e6d6-4231-93c7-e76469b6ead0"
    },
    {
      "label": "2776",
      "value": "65f1808f-f1aa-4808-a915-b3976d58abf0"
    },
    {
      "label": "2777",
      "value": "cc99c5bb-168d-4778-99a0-d3a4ce3fcc8e"
    },
    {
      "label": "3",
      "value": "3bbbd4bc-3c24-4ed7-90e0-38a90b890d2a"
    },
    {
      "label": "304",
      "value": "66a3d418-2319-44f7-8fb5-1c02932ed7df"
    },
    {
      "label": "305",
      "value": "2f061c8a-d57f-4666-bc87-0e369f8c6849"
    },
    {
      "label": "306",
      "value": "5f058d53-dc28-4ab3-8fc8-37749253600a"
    },
    {
      "label": "307",
      "value": "bef36254-3450-416f-93ec-856e30cbd12c"
    },
    {
      "label": "310",
      "value": "fd5ad19f-fbd3-4dd0-a695-103e4f5fdb5b"
    },
    {
      "label": "311",
      "value": "b544e53c-66b0-4299-8b48-1a9276be8f3c"
    },
    {
      "label": "318. 350",
      "value": "3dc22f1e-a3cc-40ae-8776-19d4f594f508"
    },
    {
      "label": "351",
      "value": "0167724d-706c-444a-91d2-e52a988871c8"
    },
    {
      "label": "352",
      "value": "79f0bf91-ff8a-47a1-96db-db24a6cbed4e"
    },
    {
      "label": "353",
      "value": "6603f738-085d-4e4a-bce9-dd60f5be0c5e"
    },
    {
      "label": "4",
      "value": "62c6b628-94aa-4082-9fd2-2160f987f2a0"
    },
    {
      "label": "400",
      "value": "fae81454-9897-48c1-8e38-e7f2d7d075a6"
    },
    {
      "label": "401",
      "value": "0ee6d83c-9284-4734-ac67-466dd9001e10"
    },
    {
      "label": "402",
      "value": "ffb96bee-e615-42d5-a05e-c515ddc672e3"
    },
    {
      "label": "403",
      "value": "1f97ca5c-92a7-43e4-98c5-e1b1b67e3a46"
    },
    {
      "label": "404",
      "value": "3e88a616-69c5-43a2-b70a-996087a08a04"
    },
    {
      "label": "405",
      "value": "9a3473a0-567e-4aff-b0a5-3b7178b606dd"
    },
    {
      "label": "412",
      "value": "fb161455-5868-48f8-aff2-a6740bbb8c1b"
    },
    {
      "label": "413",
      "value": "311d352d-68e6-4cf2-b925-78776ed48fa8"
    },
    {
      "label": "414",
      "value": "ff36149e-ab90-4a0d-8e16-eb3a5fc2fb5b"
    },
    {
      "label": "415",
      "value": "822328e9-a997-4431-add8-41a81dc50f7e"
    },
    {
      "label": "416",
      "value": "97601dae-80b1-4067-9757-ce3b42f1dc81"
    },
    {
      "label": "417",
      "value": "2b7c4bac-0514-48ea-b07e-103834639062"
    },
    {
      "label": "418",
      "value": "a7ccc3b8-6ebf-4ea4-b00c-fb4766eb298f"
    },
    {
      "label": "419",
      "value": "047747d1-cc07-4c10-af98-8497bd2379e9"
    },
    {
      "label": "420",
      "value": "68e535f2-0d3e-48eb-824f-0dcfb9d89fe8"
    },
    {
      "label": "421",
      "value": "eaab19a1-02fa-422d-a814-46acf6ec39d8"
    },
    {
      "label": "426",
      "value": "9be28350-4f0d-4230-b9b5-eaa6bd6973f1"
    },
    {
      "label": "427",
      "value": "fb7c1fd9-c683-4ba6-93d9-d07a0722ec9a"
    },
    {
      "label": "438",
      "value": "3204e98b-f27c-4a91-9969-34b4806ead7a"
    },
    {
      "label": "453",
      "value": "386c1007-bf30-4ed5-805b-c385afa5fa9f"
    },
    {
      "label": "460",
      "value": "92162b7d-f107-4752-a69a-5bfbe30f1a0b"
    },
    {
      "label": "461",
      "value": "177cf606-c568-4c47-a97c-9b7b279fb3f9"
    },
    {
      "label": "464",
      "value": "8113035f-1b22-4a04-b6f3-0822603e1cf0"
    },
    {
      "label": "465",
      "value": "f05174ff-af4f-4f10-b922-e3c593c23265"
    },
    {
      "label": "470",
      "value": "b532a7ff-03a6-4625-a026-b472296fe6f4"
    },
    {
      "label": "4700",
      "value": "a4ea5026-b32c-4872-9965-af0150acf859"
    },
    {
      "label": "4701",
      "value": "df4dd469-78d0-4cd5-8aeb-d98e8219cc66"
    },
    {
      "label": "4704",
      "value": "ca966da8-4e13-4c22-bd13-52f5b1e64b80"
    },
    {
      "label": "471",
      "value": "0ab1adef-374f-4ad1-8a61-f0b153ed3a79"
    },
    {
      "label": "472",
      "value": "bc6df11b-e667-4ed9-82b7-99b3a00ee120"
    },
    {
      "label": "473",
      "value": "b72174f2-115b-4bf3-a2c7-cb4d815534ab"
    },
    {
      "label": "474",
      "value": "59960562-7f6b-4f60-a7fa-e10152daf8e2"
    },
    {
      "label": "475",
      "value": "b1cc8e3f-c82b-4f91-8549-396ff67d1649"
    },
    {
      "label": "478",
      "value": "9f190dd0-a916-4a87-b180-6cca00669be3"
    },
    {
      "label": "479",
      "value": "f6ca8a09-e31b-435c-8b8d-ef2842d8210b"
    },
    {
      "label": "482",
      "value": "ed551ab3-16b5-44d5-97cf-1fe7a605b5e1"
    },
    {
      "label": "483",
      "value": "a1b4b156-57d0-4d33-8281-cb50688adc75"
    },
    {
      "label": "484",
      "value": "bf4a932e-0c45-4b74-b61e-3ed3bd8c8394"
    },
    {
      "label": "485",
      "value": "97f3a174-06c9-46aa-96ec-02c15cbb9ad0"
    },
    {
      "label": "486",
      "value": "73d3edb1-be79-4257-b3f1-edc97cb1f152"
    },
    {
      "label": "487",
      "value": "a39ba4f8-5f43-4d9e-932f-5c227369da22"
    },
    {
      "label": "488",
      "value": "c120143e-c82a-4e8e-b6f7-4fe94121a535"
    },
    {
      "label": "489",
      "value": "8ae8d9a7-ae2c-4a6d-8fc2-4b182e47b8c9"
    },
    {
      "label": "490",
      "value": "2e89e0d8-ef95-4076-9487-e00a22d5868d"
    },
    {
      "label": "491",
      "value": "412e1125-423b-4c80-b0b7-e9f216b7c11b"
    },
    {
      "label": "494",
      "value": "4f8fff50-ff9c-410a-ac2f-aa1e8c127471"
    },
    {
      "label": "495",
      "value": "7e8d305f-5d47-4dfe-bf1b-079686d9c09e"
    },
    {
      "label": "498",
      "value": "d7f64892-a851-4b3a-9f38-813be5d8026d"
    },
    {
      "label": "499",
      "value": "3e3589c1-9609-472e-87e8-8d5b79d096c5"
    },
    {
      "label": "508",
      "value": "94ddf8f5-6758-4ad1-903d-d77c7527ee3f"
    },
    {
      "label": "509",
      "value": "539f0433-4c75-4056-97d1-01779d2592be"
    },
    {
      "label": "510",
      "value": "fc15a608-aa77-4e44-bbff-cbf8f63ef09c"
    },
    {
      "label": "5104",
      "value": "4620f98b-9beb-4d2a-900f-62fa827b0ef3"
    },
    {
      "label": "5105",
      "value": "c901c8e4-fd66-4c40-9b32-505a4fec9904"
    },
    {
      "label": "511",
      "value": "39371552-9432-4bb7-b351-efa605a2cc95"
    },
    {
      "label": "514",
      "value": "4ad334ff-2ed4-4187-a3ae-db2b8f20c3da"
    },
    {
      "label": "515",
      "value": "46e50889-d389-4b5f-8241-a9bdd6c88592"
    },
    {
      "label": "520",
      "value": "c6df5b76-8a83-450d-a67b-f2f6d8dd74bf"
    },
    {
      "label": "521",
      "value": "ad0c8678-7f06-4dc9-8473-518ab2b85641"
    },
    {
      "label": "532",
      "value": "55032ff9-dbf3-4426-9262-23a98e1acf68"
    },
    {
      "label": "533",
      "value": "bd48f1e6-27ee-4c72-bf98-c77ac2f8d4dc"
    },
    {
      "label": "534",
      "value": "fd073aa7-5cfe-42ec-818f-8d43532144a1"
    },
    {
      "label": "535",
      "value": "7662add9-3cf2-46c6-826a-5a3b62da8c91"
    },
    {
      "label": "554",
      "value": "1f3aade6-0882-45dd-a1cf-b0776641b823"
    },
    {
      "label": "555",
      "value": "d6b3964a-96ce-4e68-971b-08a73a2b3b54"
    },
    {
      "label": "570",
      "value": "0dccbed4-7022-4d12-8dc2-98ab6884b775"
    },
    {
      "label": "571",
      "value": "a9d0c11c-f974-4c8c-8366-6efcfd09f711"
    },
    {
      "label": "5723",
      "value": "db867ddd-a322-46c4-bf65-9ecc8eddc858"
    },
    {
      "label": "5726",
      "value": "04e1b775-61fa-43fa-8553-09334c06a58c"
    },
    {
      "label": "5727",
      "value": "057de76d-8d60-4701-89b9-65761cb60593"
    },
    {
      "label": "5728",
      "value": "114d29a0-567c-453e-8664-cfa39815b143"
    },
    {
      "label": "578",
      "value": "7029031c-38aa-4bb5-ae02-0b32e8645155"
    },
    {
      "label": "579",
      "value": "8eb42259-53e5-46d8-aa36-5024ac2f4f15"
    },
    {
      "label": "584",
      "value": "e43831fb-1886-4987-a479-f6650b894a0d"
    },
    {
      "label": "586",
      "value": "ce98cb65-7e29-4ae8-81d8-1c2529fb19f6"
    },
    {
      "label": "592",
      "value": "785c5ab9-2fa1-4182-a97c-257e86be40ba"
    },
    {
      "label": "593",
      "value": "75ef3ec1-3a8b-42ae-adb5-d7b5b6b8a54f"
    },
    {
      "label": "600",
      "value": "928ea78b-f2a3-4b3d-841c-d350e92fa2d0"
    },
    {
      "label": "601",
      "value": "728b6efc-ac99-4bbe-80ed-e1cf6091136e"
    },
    {
      "label": "602",
      "value": "e7a8882d-96bb-4c4c-84c9-06188181b4ba"
    },
    {
      "label": "603",
      "value": "fc768324-0c43-4602-a69c-6a654701684c"
    },
    {
      "label": "604",
      "value": "fdfe3d56-1e0c-4208-a181-1a466d17f2da"
    },
    {
      "label": "605",
      "value": "6057366d-d43a-48c9-8542-481f93929a82"
    },
    {
      "label": "606",
      "value": "570ac4ec-0457-405e-842f-382f16fb1c5a"
    },
    {
      "label": "607",
      "value": "9ad47462-cbf8-4f06-af31-88ed0ce075df"
    },
    {
      "label": "608",
      "value": "a4abd884-b2e7-48af-b896-f38ed08ae140"
    },
    {
      "label": "609",
      "value": "03d298b1-b94b-4bdc-a5f0-351af0f6fd1a"
    },
    {
      "label": "610",
      "value": "0d44f63e-e809-4499-9fbb-0006a40e5c09"
    },
    {
      "label": "611",
      "value": "d7f0fc31-289b-4baf-9967-923db07dc802"
    },
    {
      "label": "612",
      "value": "72f43bdf-f823-4496-8e88-84c7dc833c8e"
    },
    {
      "label": "613",
      "value": "e2599223-d9ce-442f-9fd7-261213b81be5"
    },
    {
      "label": "614",
      "value": "3ddf9824-c934-4081-b334-b681fe99a701"
    },
    {
      "label": "615",
      "value": "99844fd3-362b-4272-a5dc-7649227fa455"
    },
    {
      "label": "618",
      "value": "1eb2679f-2dbe-4091-85dd-de9c8a03a09c"
    },
    {
      "label": "619",
      "value": "9dee2dc0-94d6-47a0-97da-5b87689ad2c4"
    },
    {
      "label": "624",
      "value": "edce5175-54a6-4c6a-8724-5cfbece4c86e"
    },
    {
      "label": "625",
      "value": "7d74c82d-52d9-49e4-be86-3026ac8c2012"
    },
    {
      "label": "650",
      "value": "535d8908-cab5-4183-912a-d7274e9f4594"
    },
    {
      "label": "654",
      "value": "9632e986-d8fa-4578-87e9-6112ab4b8d6f"
    },
    {
      "label": "655",
      "value": "bb8d1b49-910d-4891-a02a-2671a7770d31"
    },
    {
      "label": "656",
      "value": "cd63adad-f31b-4822-9d22-e9bdb29c7ae9"
    },
    {
      "label": "657",
      "value": "9fda86f3-61d7-4c92-916f-d48470c2227c"
    },
    {
      "label": "665",
      "value": "9159cea9-827c-4fd6-86cf-a44c96b936d0"
    },
    {
      "label": "670",
      "value": "afdfece9-ae9a-411f-bf48-03f6066cc21c"
    },
    {
      "label": "671",
      "value": "91496a70-297e-48bf-b473-b3a5e077a278"
    },
    {
      "label": "6712",
      "value": "64467ea7-6d97-4b9d-af64-983b52e06711"
    },
    {
      "label": "6713",
      "value": "037be6be-6ca3-4ea7-a7d3-ace40fee7990"
    },
    {
      "label": "6715",
      "value": "e5d53e0c-872d-43f1-85a6-637c084a3b1e"
    },
    {
      "label": "6717",
      "value": "7fe12c26-22b5-4d01-834a-f79ec5a36711"
    },
    {
      "label": "6718",
      "value": "3c3f6f49-6610-408f-8c84-d74d593c7b55"
    },
    {
      "label": "6719",
      "value": "66a55a1f-65b7-4560-87dc-5c27f743b78e"
    },
    {
      "label": "6720",
      "value": "7a005360-9dce-4fd0-97a5-f246d61f3b6a"
    },
    {
      "label": "6721",
      "value": "a2dd9019-a9ac-4022-9ac5-ff1ab7ddfd1c"
    },
    {
      "label": "6730",
      "value": "2275ca06-5ee9-4fd4-b1ad-b55823851d4f"
    },
    {
      "label": "6731",
      "value": "e61065ee-f361-4002-8c56-a77c18ad9f7b"
    },
    {
      "label": "6732",
      "value": "2e2365ac-1632-46ae-b8f6-b14ea7d4c7e2"
    },
    {
      "label": "6733",
      "value": "5d44df85-cfbe-40a6-a7b8-07eeb7a7ba8b"
    },
    {
      "label": "704",
      "value": "92332691-d4dd-4a7b-9c59-62f6a3481c36"
    },
    {
      "label": "706",
      "value": "877ff376-58ea-434a-85f4-1d4c1b769d1e"
    },
    {
      "label": "720",
      "value": "a45cdb1a-58e6-44ae-a081-c866f1ebfe98"
    },
    {
      "label": "738",
      "value": "f4ea2fc3-9dcf-44b3-abfa-5db9024a40bc"
    },
    {
      "label": "740. 114",
      "value": "cb5deeba-9ea4-426f-b84e-387db462968c"
    },
    {
      "label": "741",
      "value": "6d3fbae3-7487-42f5-8a9b-11794c929208"
    },
    {
      "label": "756",
      "value": "b95ef7c7-94c4-4258-b9e9-beb9900fa12f"
    },
    {
      "label": "760",
      "value": "43c231bc-bd64-4806-a1e4-b12bd6867573"
    },
    {
      "label": "761",
      "value": "c6ee204c-fad0-4863-a634-833565302262"
    },
    {
      "label": "762",
      "value": "8085b3e0-a170-4dfe-a3fe-06650497b3e6"
    },
    {
      "label": "763",
      "value": "5e09115f-9490-4961-bf00-aba8dd64e493"
    },
    {
      "label": "764",
      "value": "5df713f6-8f67-4a80-9d48-a517b613cc69"
    },
    {
      "label": "765",
      "value": "6fea8836-c3b3-4387-a3b8-53c3b831c4b6"
    },
    {
      "label": "766",
      "value": "030be92e-7367-450e-ba19-a00caa255609"
    },
    {
      "label": "767",
      "value": "1a78e125-5093-43ad-af6a-e02749dd1a8f"
    },
    {
      "label": "782",
      "value": "02ca4ddb-ab64-4536-b794-6f0e181275de"
    },
    {
      "label": "783",
      "value": "6e537688-b4a4-4a24-b33f-207aeca1b0d9"
    },
    {
      "label": "784",
      "value": "73b96eb6-4cbc-4559-a577-2eb7eb32e6ca"
    },
    {
      "label": "785",
      "value": "57fdc2f1-cde8-4c60-9730-87b889e7a7e6"
    },
    {
      "label": "792",
      "value": "1e48d3fc-57fc-4c5f-bc8c-261d59a13f90"
    },
    {
      "label": "793",
      "value": "0bafde1e-06fb-4676-946a-ecaf027466d3"
    },
    {
      "label": "8017",
      "value": "06130799-88c6-4639-b0c4-428733e72a70"
    },
    {
      "label": "8020",
      "value": "529c13de-da9f-4254-87d0-9e75030ae311"
    },
    {
      "label": "8024",
      "value": "a7da749d-4a67-4de9-8839-4cb27bfc81f0"
    },
    {
      "label": "8025",
      "value": "56c66ea2-961e-4005-9bd1-10a29522bc0e"
    },
    {
      "label": "8030",
      "value": "3aac5606-9220-4d53-8395-c2bcf89b4d24"
    },
    {
      "label": "8031",
      "value": "d6c97f62-949b-46eb-9273-8f4b9473a9fa"
    },
    {
      "label": "8038",
      "value": "eab105de-4f6f-4dc9-b366-72f4fba5b488"
    },
    {
      "label": "8540",
      "value": "db1241fb-0851-4cf3-b652-b584259b1ca9"
    },
    {
      "label": "8541",
      "value": "b1426785-b53e-4aaa-b782-1876047a614c"
    },
    {
      "label": "8554",
      "value": "eb732b3b-7d7b-426f-885f-fd76b05f602a"
    },
    {
      "label": "8555",
      "value": "3dce0d9e-c90b-48c5-9ccc-aa44346e0a18"
    },
    {
      "label": "8600",
      "value": "e5a583ed-b82c-4622-b090-d00870f405d8"
    },
    {
      "label": "8601",
      "value": "40bc6f5d-ab0a-492d-8f86-dfd513ab68e2"
    },
    {
      "label": "8602",
      "value": "0e4e07d9-afba-483e-bbd8-795add225233"
    },
    {
      "label": "8603",
      "value": "b636e58e-59df-4124-b864-421333111671"
    },
    {
      "label": "8604",
      "value": "71f78657-b104-47f7-bcb2-0c2b1ba9ba62"
    },
    {
      "label": "8605",
      "value": "1465914e-8f8b-4d42-bfe9-91ad4434b762"
    },
    {
      "label": "8606",
      "value": "76139dca-9a9d-4e8a-ab1c-c49532b27485"
    },
    {
      "label": "8607",
      "value": "172419e0-8745-4a13-b89f-8c621ae371a8"
    },
    {
      "label": "8608",
      "value": "ea8faa20-9d68-4cf7-9498-148209e0491d"
    },
    {
      "label": "8609",
      "value": "b17b14e3-4953-4e4e-b6fb-bb68ce8834b2"
    },
    {
      "label": "8640",
      "value": "8bd5497c-367e-44d9-84d7-7c8a94510321"
    },
    {
      "label": "8641",
      "value": "12356f1b-eeea-41a6-a5d1-81a9df94e997"
    },
    {
      "label": "8642",
      "value": "b6d5f2e3-afc9-49ed-a867-c13c2cec7ab7"
    },
    {
      "label": "8643",
      "value": "972ec167-b073-49cd-9d9c-a05217bc9eef"
    },
    {
      "label": "8644",
      "value": "1544dd16-e045-482c-bdeb-85fc95c450c7"
    },
    {
      "label": "8645",
      "value": "b149478b-6db1-4581-97a6-c82782dbc109"
    },
    {
      "label": "8646",
      "value": "9e02ec6d-ada7-45e9-b7ff-93d04a9f7ef9"
    },
    {
      "label": "8647",
      "value": "537e8d77-8a2c-4905-bde8-6cc46e18589d"
    },
    {
      "label": "8648",
      "value": "231db74e-c07a-48f2-b558-95726927305d"
    },
    {
      "label": "8650",
      "value": "7151c6ae-a061-411a-8a43-2c0438ed27e0"
    },
    {
      "label": "8651",
      "value": "988cceed-0bd5-4b38-813e-2a9439358f41"
    },
    {
      "label": "8652",
      "value": "2daa1bf4-c050-4c7b-b092-5c9da4df6db7"
    },
    {
      "label": "8653",
      "value": "a1821700-fe84-4615-9a59-afee5a35fd19"
    },
    {
      "label": "8654",
      "value": "2445acfa-74cb-4bb1-a97d-d7e72d3a53cd"
    },
    {
      "label": "8655",
      "value": "5312af40-25be-49cb-b59c-f48b5f7d7f8e"
    },
    {
      "label": "8656",
      "value": "ce1005da-fd93-4002-9805-3c5adee5d646"
    },
    {
      "label": "8657",
      "value": "f9b7f678-ad19-4135-8a7b-d0dc176f4a1c"
    },
    {
      "label": "8658",
      "value": "36786b75-a01c-4d0c-a867-8c362bb06691"
    },
    {
      "label": "8659",
      "value": "e3b16733-6589-405b-9c36-745e957c72fa"
    },
    {
      "label": "8660",
      "value": "b4b66e5b-8775-4737-b8f4-021c6499e502"
    },
    {
      "label": "8661",
      "value": "6f717a73-4871-4f4a-b6a5-fc4e9686c1a9"
    },
    {
      "label": "8662",
      "value": "2ed4039f-339b-4db6-96a5-bb57437acd46"
    },
    {
      "label": "8663",
      "value": "2490ebc1-50c4-4d0e-b903-77ee43825d8a"
    },
    {
      "label": "8664",
      "value": "f175312b-68ab-4e04-b0da-499af77acec1"
    },
    {
      "label": "8665",
      "value": "08f1ff42-3d9f-4624-b109-97401985a2e0"
    },
    {
      "label": "8666",
      "value": "9cab96ef-ef72-4106-bed4-6a75b140c1b7"
    },
    {
      "label": "8667",
      "value": "b52ef388-d634-491d-8fa6-7d5f9b138835"
    },
    {
      "label": "8668",
      "value": "883c8cd6-330b-4aa5-a8aa-047ccd0a1511"
    },
    {
      "label": "8669",
      "value": "06ef6d86-0446-4777-adc2-369f671e189c"
    },
    {
      "label": "8678",
      "value": "8df05a61-a3ec-4d24-a9bd-b6c7ec4ed819"
    },
    {
      "label": "8679",
      "value": "bad2a05a-224d-48b3-838d-7d7b4f5a7bc6"
    },
    {
      "label": "8684",
      "value": "517ffbbc-83c6-45dc-ae06-94428e517f6b"
    },
    {
      "label": "8685",
      "value": "5ed8990c-8738-41a7-a4a2-4253c16977d1"
    },
    {
      "label": "8690",
      "value": "36f68dd3-a8fe-4936-9d93-7b2be782abe4"
    },
    {
      "label": "8691",
      "value": "18ccf98e-08b4-43cc-9986-4985902788f9"
    },
    {
      "label": "8692",
      "value": "fb65f99d-1d32-4b14-897f-8bae8e5a6fc7"
    },
    {
      "label": "8693",
      "value": "316a1962-05c6-4066-b5fc-729c7683b7f0"
    },
    {
      "label": "8694",
      "value": "b719aec6-9c40-472d-ba9b-89252b78375c"
    },
    {
      "label": "8695",
      "value": "c3e64c38-bdbf-4e37-809a-ebecf59a0f07"
    },
    {
      "label": "8696",
      "value": "3d843079-3d87-45c3-9511-5275cbe988b3"
    },
    {
      "label": "8697",
      "value": "72a7eec6-fb8b-44e0-a654-1e2b664152fa"
    },
    {
      "label": "8700",
      "value": "6f031071-eec6-4922-8354-bc0c2a9ce7d8"
    },
    {
      "label": "8711",
      "value": "de958d36-4e67-4036-b8fd-aac7c74d96ef"
    },
    {
      "label": "8712",
      "value": "4eca0e67-4bde-4343-babd-4c6507956de3"
    },
    {
      "label": "8713",
      "value": "701a6593-13e4-4357-a633-2ac5af589632"
    },
    {
      "label": "8714",
      "value": "2c13fe41-2888-4c38-84d9-a3e85940d862"
    },
    {
      "label": "8715",
      "value": "b46fb60f-446c-4022-86ec-063811a8ad0c"
    },
    {
      "label": "8716",
      "value": "e1ad3e33-e20a-43bb-bf53-bcceaf063c1f"
    },
    {
      "label": "8717",
      "value": "e49eeedc-93aa-4804-b7c5-7acf841b94f8"
    },
    {
      "label": "8718",
      "value": "971123a3-1c9a-4274-a48e-9c5e5c46f00b"
    },
    {
      "label": "8719",
      "value": "24b4444b-88a2-481c-ae65-e28d2c7f6b9e"
    },
    {
      "label": "8720",
      "value": "1ef28c61-676f-4816-86d9-31fe47c7d8e9"
    },
    {
      "label": "886",
      "value": "24b68aad-dd03-4520-8be0-534d30b79a13"
    },
    {
      "label": "887",
      "value": "586b2171-2afb-4f18-85ee-ac0b982d4586"
    }
  ],
  "ad949d75-2138-422b-80d0-446fc2090b9f": [
    {
      "label": "4025",
      "value": "a4025cdf-b40b-4dd3-83d8-627c294b07ac"
    },
    {
      "label": "4026",
      "value": "cfd0fbef-2191-4f1a-95ac-c1eced10e5db"
    },
    {
      "label": "4027",
      "value": "8b21e598-326e-4301-bec5-7dea3130cb8f"
    },
    {
      "label": "4523",
      "value": "f072d93a-9d40-427a-be6b-aa88a78a450f"
    },
    {
      "label": "4529",
      "value": "c3ec30cf-4b0f-4392-9065-5ee4995d0e84"
    },
    {
      "label": "9310",
      "value": "7c987f63-3c71-4382-9d7c-db301e2f21e5"
    },
    {
      "label": "9311",
      "value": "ae71d005-a0a5-4e44-b08e-f53ba52716ab"
    },
    {
      "label": "9334",
      "value": "bdec567e-d7aa-45ce-8d2d-b8d51d5e6671"
    },
    {
      "label": "9335",
      "value": "f333bd13-e051-4f49-91e1-71362b36a6a9"
    },
    {
      "label": "9340",
      "value": "d8a2d33f-6ece-4ef6-86ce-80e0e79c6b5b"
    }
  ],
  "0a0ada4e-3c26-4a18-92ec-b6f14414b8e7": [
    {
      "label": "SN482",
      "value": "0c673463-4b09-4678-bd0a-494342315012"
    },
    {
      "label": "SN487",
      "value": "51311856-afac-4ba2-bdb0-794b87564a53"
    },
    {
      "label": "SN481",
      "value": "3064b42a-1b29-4735-a9a3-e30473c73746"
    },
    {
      "label": "SN491",
      "value": "88ebae5a-bf50-402b-b2fa-f4948f350e7e"
    }
  ],
  "967f0f2f-77aa-45d5-a804-c9d8ebad4c21": [
    {
      "label": "TK607",
      "value": "58bf779b-99a9-479d-90da-d7b65b9d7606"
    },
    {
      "label": "TK637",
      "value": "9e0858f6-be3f-46ee-b80b-3dc8cac1b115"
    }
  ],
  "5c263df0-210a-460a-8367-a6748e74e325": [
    {
      "label": "659",
      "value": "7cb1d940-1fc5-4afb-ba43-f2b41b7e7aa6"
    },
    {
      "label": "755",
      "value": "79829d56-6e39-4542-8d4d-e86ef5513cd5"
    },
    {
      "label": "831",
      "value": "1c844720-af61-4805-864e-ede42522ddcd"
    },
    {
      "label": "839",
      "value": "765f22e6-a1ad-4f26-9923-bc3ae5a0c71b"
    },
    {
      "label": "925",
      "value": "58aed6fb-b219-438c-a70f-13612766d166"
    },
    {
      "label": "963",
      "value": "484bc6a7-5efc-421a-af64-b9a9bcf65e97"
    },
    {
      "label": "985",
      "value": "90272656-76d5-4159-bb79-9cffe59ae1a6"
    },
    {
      "label": "987",
      "value": "8a33deee-c6b0-49db-8eab-91c95248633e"
    },
    {
      "label": "991",
      "value": "e66234c4-2d73-4249-884c-2cf83ac86c74"
    },
    {
      "label": "993",
      "value": "29326297-0d7c-4ac7-9c8a-9d345a47b85a"
    },
    {
      "label": "995",
      "value": "5f41533f-31a3-4ab9-adc7-55f2d00ab509"
    },
    {
      "label": "997",
      "value": "883211b7-b0a4-4de7-9c06-2a6d0c113d00"
    },
    {
      "label": "999",
      "value": "60deb036-ddbd-493a-a4af-9acde4bfdead"
    }
  ],
  "526f97b7-a388-49c0-9f38-9d5a191c4adf": [
    {
      "label": "6043",
      "value": "54b185e9-0dd0-422c-8da1-82e13125d399"
    },
    {
      "label": "6044",
      "value": "b4df68a4-1f3e-4d34-8f79-54b0a1f55ace"
    }
  ],
  "76120e5c-b13a-4f58-a1c5-fe6aff901324": [
    {
      "label": "4934",
      "value": "77da7537-746a-4bb4-8cd1-6338760ab84f"
    },
    {
      "label": "4935",
      "value": "953afda0-3746-434d-97dc-0aa1bfa78592"
    },
    {
      "label": "4941",
      "value": "a3e01583-4b7d-47a3-aae1-1612154a8f6f"
    },
    {
      "label": "767",
      "value": "4f91eab2-117d-48b1-89eb-1393a8caead0"
    },
    {
      "label": "768",
      "value": "75da1887-d92e-40f6-b8e5-b5a10e709f73"
    },
    {
      "label": "786",
      "value": "c5209bca-b9e3-4aec-a1d3-017aa9eb8a14"
    }
  ],
  "da6ebf5b-e853-4e98-aa81-42e1622695b1": [
    {
      "label": "3102",
      "value": "2b814da8-87ff-4bb4-9e3e-e6908aa06ae8"
    },
    {
      "label": "3103",
      "value": "7470d9ba-59cf-49e2-a6ba-caa073508383"
    },
    {
      "label": "3104",
      "value": "90f4edbf-32b6-4aa5-8d9f-8f6c9e2264b1"
    },
    {
      "label": "3105",
      "value": "76cfb956-18f1-46b3-a5a1-233b3fceb785"
    },
    {
      "label": "3106",
      "value": "3db805b5-e269-4969-adee-ebc10f9b2559"
    },
    {
      "label": "3107",
      "value": "66d8666b-fc30-491b-9f7a-8b42c7be9f61"
    },
    {
      "label": "3108",
      "value": "f972d45a-7baa-4bc3-9f92-4cdb587da3f7"
    },
    {
      "label": "3109",
      "value": "43265140-b07a-4bc7-ae55-b250bc6b25b9"
    },
    {
      "label": "3110",
      "value": "1c23e60b-9bc1-4ec9-a0cf-202970b8c4c7"
    },
    {
      "label": "3111",
      "value": "7b83d273-e8a9-49f8-9a41-74bbe75ab791"
    },
    {
      "label": "3267",
      "value": "6c446e96-8ba5-48a1-95b6-0725bf76af6e"
    },
    {
      "label": "5191",
      "value": "62795cb3-7fcb-462f-85db-80ca9a0812fb"
    },
    {
      "label": "5500",
      "value": "778ed91d-8d9a-4fd3-8f76-daeb05f15cca"
    },
    {
      "label": "5501",
      "value": "7d7b5f08-a9ba-4ed9-b1ae-0624d660b773"
    },
    {
      "label": "5502",
      "value": "852996ef-82bf-4973-8601-53a38bdd1616"
    },
    {
      "label": "5503",
      "value": "ab0c845d-acfd-4b52-9332-2e9d4c07e6fe"
    },
    {
      "label": "5504",
      "value": "2d37a5f5-b8ba-446b-8edf-1834e05fd878"
    },
    {
      "label": "5506",
      "value": "eab77b3a-b2ac-495a-ad7b-c7a38b4b6a69"
    },
    {
      "label": "5507",
      "value": "29164e7d-23a3-4e50-9101-f240dd1a13e8"
    },
    {
      "label": "5508",
      "value": "2a24e49b-6c78-4f9e-b513-4aebc4da99b3"
    },
    {
      "label": "5511",
      "value": "c0576112-41ba-4606-9502-40d1a87e7aa8"
    },
    {
      "label": "5513",
      "value": "1fc5ce10-4916-41a6-a440-4b86f9c2e344"
    },
    {
      "label": "5515",
      "value": "e9774059-c393-43fb-9012-cf191fbde9d1"
    },
    {
      "label": "5516",
      "value": "b5d3b8c7-9572-4a1e-882f-02d40c9c517e"
    },
    {
      "label": "5519",
      "value": "590b0c61-e630-4d04-9a69-6fce675891a3"
    },
    {
      "label": "8004",
      "value": "6a59c9ba-e9f9-4c57-922c-a9bdf0622cf1"
    },
    {
      "label": "8006",
      "value": "6eeaca26-112e-4b73-89f8-64109cda44fd"
    },
    {
      "label": "8007",
      "value": "6c1b434c-9791-4a93-9510-0e016e6684e7"
    },
    {
      "label": "8011",
      "value": "8a892b24-24af-4db6-a5bb-183a6a647093"
    },
    {
      "label": "8055",
      "value": "f82b21de-5a3e-4566-800c-b71571bcd8f6"
    },
    {
      "label": "8067",
      "value": "1dad3518-dce5-49ec-964d-7febdc4417dd"
    },
    {
      "label": "8069",
      "value": "5206e5a5-9c6d-4592-b362-3bc704df810f"
    },
    {
      "label": "8071",
      "value": "8c630c1f-ad2a-491d-983d-525bf5934f76"
    },
    {
      "label": "8072",
      "value": "ce1ee4f7-1c5b-49e5-95d8-82d817bdf9d2"
    },
    {
      "label": "8074",
      "value": "240c5b70-e6d4-483b-9249-60f2005de825"
    },
    {
      "label": "8075",
      "value": "4b5adfc8-656a-4dc6-a2ab-a342b3213e73"
    },
    {
      "label": "8079",
      "value": "9229e258-8fef-4e70-a81e-efbe81b20829"
    },
    {
      "label": "8082",
      "value": "cc086f75-2a1c-4757-a357-065fbfc1ce67"
    },
    {
      "label": "8085",
      "value": "e79e51bc-918b-4d9f-8477-27cd12cba71a"
    },
    {
      "label": "8087",
      "value": "8e986548-bfa2-4385-b592-2379c033ce55"
    },
    {
      "label": "8090",
      "value": "72b7ad92-ead9-492f-974c-34f2b8595e66"
    },
    {
      "label": "813",
      "value": "2c5ee0a5-fe48-452b-b4fe-cc0a17d16d5f"
    },
    {
      "label": "814",
      "value": "3aeec781-0f38-4eb0-af45-308ad9387a63"
    },
    {
      "label": "815",
      "value": "0d46e089-b6d2-428f-b5db-481f63e4c7f8"
    },
    {
      "label": "8201",
      "value": "9e58b148-4943-4e13-af41-ecd466efe2cc"
    },
    {
      "label": "8203",
      "value": "d98f3263-c845-4f50-9941-5b5de4b3c386"
    },
    {
      "label": "8205",
      "value": "f335f44c-ac49-45ad-af40-c2ba75fc2214"
    },
    {
      "label": "8207",
      "value": "8fb85c7c-62d0-4be0-a775-41d4f497374a"
    },
    {
      "label": "8208",
      "value": "5fdb5f3a-59dc-432c-83d1-062f15523ff4"
    },
    {
      "label": "8211",
      "value": "dd5c2d5f-c6fc-405a-8fb5-2316edc1c70c"
    },
    {
      "label": "890",
      "value": "09987c49-b7c5-4dd9-b159-976a99e41db8"
    },
    {
      "label": "891",
      "value": "5f8baf3b-3f91-4548-a6c2-aa5d08e5a72f"
    }
  ],
  "f7f74cc3-7af7-4fdb-b721-97d65ff22305": [
    {
      "label": "174",
      "value": "69e71a3c-ab17-4b76-8f73-e4facf57c43f"
    },
    {
      "label": "2224",
      "value": "57d1241e-6626-4b70-a894-433c77f69c68"
    },
    {
      "label": "2234",
      "value": "fbb22e17-4ae1-46ac-9f63-c2856b314e59"
    },
    {
      "label": "2246",
      "value": "1893a2f8-fcfc-4dfe-a47c-d03fb67eba33"
    },
    {
      "label": "4128",
      "value": "09340b5d-29b9-4a28-b4bc-3e8e23d4ec9d"
    },
    {
      "label": "4129",
      "value": "2fdf5438-ae7e-4dc8-9f47-f08bcb8a4cd1"
    },
    {
      "label": "4130",
      "value": "ed2c61c8-5f44-4420-8335-42b7820ea00b"
    },
    {
      "label": "4131",
      "value": "01beec92-5680-4699-adf7-88795f6f9f57"
    },
    {
      "label": "4132",
      "value": "37df840f-4a6c-45e4-92ec-7ff8d49f9442"
    },
    {
      "label": "4133",
      "value": "f4f850fa-a731-47b2-b5e7-043e98316a2c"
    },
    {
      "label": "4134",
      "value": "06b5becd-2abb-4abd-a8e6-7f8d6af626af"
    },
    {
      "label": "4135",
      "value": "ab8d263e-0e10-40e9-9cbc-26f51a279baf"
    },
    {
      "label": "4136",
      "value": "5bb2d1e8-e5c9-47cf-b46d-ec64cf02de3d"
    },
    {
      "label": "4137",
      "value": "4c98d278-466f-48a5-861e-6179ded391f1"
    },
    {
      "label": "4138",
      "value": "7c036e4f-84a9-4a5c-a7a0-0e285e3b9c52"
    },
    {
      "label": "4139",
      "value": "26cb5a02-9447-4f99-8c37-2b9abb2962c9"
    },
    {
      "label": "4140",
      "value": "70fa1f86-32ec-499c-ab47-3be57983e701"
    },
    {
      "label": "4141",
      "value": "788e0fd5-3caf-41aa-8eca-8a24440964ad"
    },
    {
      "label": "4142",
      "value": "d844be48-359f-4a68-8d2d-6b38d64db3de"
    },
    {
      "label": "4143",
      "value": "3de8c235-71f8-4a6d-befd-60e1d151526c"
    },
    {
      "label": "4144",
      "value": "c9edce52-7e48-4f3b-b84c-0792896ce849"
    },
    {
      "label": "4145",
      "value": "ffd4693f-e348-46dd-8ebf-c497d47b2fac"
    },
    {
      "label": "4146",
      "value": "1af04afe-76f9-4982-a51d-f2ab89c49b95"
    },
    {
      "label": "4147",
      "value": "b0f47996-a22d-4253-9bcb-57e25918bd15"
    },
    {
      "label": "4149",
      "value": "902fe5d8-a5fa-48c8-8044-281288bf1928"
    },
    {
      "label": "4150",
      "value": "74311a25-d3bb-4357-938e-ddff89b855de"
    },
    {
      "label": "4151",
      "value": "a77f3cce-ec7e-4ad1-a763-8dd0cedb97d7"
    },
    {
      "label": "4152",
      "value": "3e25d56a-7952-4cc0-b153-2e9258a3342c"
    },
    {
      "label": "4153",
      "value": "a9956d0f-d89e-4cdf-842f-0b88617c82bf"
    },
    {
      "label": "4154",
      "value": "b39792bd-7ed9-4747-a620-8cad5d7bd692"
    },
    {
      "label": "4155",
      "value": "86700636-cc1b-4869-ab2d-9d2780e7c455"
    },
    {
      "label": "4156",
      "value": "80ae5aab-b3b9-48de-ab64-304b4d095a1f"
    },
    {
      "label": "4157",
      "value": "bde7f51e-0d59-4613-9cf6-70b636647fa1"
    },
    {
      "label": "4158",
      "value": "4ddfa685-a6c0-476d-aafc-f4398214b583"
    },
    {
      "label": "4159",
      "value": "7b5215a3-5670-46b3-a9f7-ef30f5651a58"
    },
    {
      "label": "4160",
      "value": "90ce2456-a0a9-4619-b77d-a27d26ee8857"
    },
    {
      "label": "4161",
      "value": "2e634f0e-cfbe-4b0c-b2a2-48f0aa5131c3"
    },
    {
      "label": "4162",
      "value": "782e927e-7c1e-4fb4-ab15-d2e1afa265e6"
    },
    {
      "label": "4163",
      "value": "3b42abfb-e317-466e-a7fb-0109554fad55"
    },
    {
      "label": "4164",
      "value": "51923a58-f395-41ec-bf04-4aaa00e7ce8d"
    },
    {
      "label": "4165",
      "value": "9446ae82-547a-4f5e-9e82-1604d2160edc"
    },
    {
      "label": "4166",
      "value": "cc6be1d0-3de4-4d6f-9092-5b77929340d1"
    },
    {
      "label": "4167",
      "value": "929cd44d-c9ef-49bb-9510-e55d70436cb7"
    },
    {
      "label": "4168",
      "value": "f03ac848-a449-483d-ad0b-b579246b1ed9"
    },
    {
      "label": "4170",
      "value": "57d47171-3481-42a1-a56f-1e0117c3a0fe"
    },
    {
      "label": "4171",
      "value": "b6e37c0f-1ea0-4ed3-a54c-ad5ed0efb29a"
    },
    {
      "label": "4172",
      "value": "c22b124c-4c15-49f5-ba5f-1368d737d33a"
    },
    {
      "label": "4173",
      "value": "8369b93e-85e9-4f83-aafb-75ba835329cc"
    },
    {
      "label": "4174",
      "value": "a7a8534f-281d-4395-b13b-88ef1e0b15cb"
    },
    {
      "label": "4175",
      "value": "8bde98da-bb04-4049-a74e-381e3cc803a3"
    },
    {
      "label": "4176",
      "value": "6f10ebc7-513d-4bba-b19b-fd8339e2d992"
    },
    {
      "label": "4177",
      "value": "cc8cf472-18f8-4e23-87b3-9aa4d19923f8"
    },
    {
      "label": "4178",
      "value": "ec4a2c6a-cdb0-4b6d-adf0-23e065a3d1d4"
    },
    {
      "label": "4179",
      "value": "3919c3e6-466b-4924-86f0-40decc2e45fd"
    },
    {
      "label": "4180",
      "value": "f0e42990-99a9-4a4d-89ad-c6d31f231de0"
    },
    {
      "label": "4181",
      "value": "0f3b5e2b-bdfd-4d9d-8d78-9a07094b5344"
    },
    {
      "label": "4183",
      "value": "70629535-7fe7-44b1-9e4d-0110b09ff764"
    },
    {
      "label": "4184",
      "value": "7c2ae738-400b-4b31-b834-d26077d7205a"
    },
    {
      "label": "4185",
      "value": "df7266f0-09ce-4c43-b363-d46758288cfe"
    },
    {
      "label": "4186",
      "value": "b657af37-19e3-40d8-97b1-042673edd7ff"
    },
    {
      "label": "4187",
      "value": "4b672a06-7b28-45d7-93bd-7ca663faa390"
    },
    {
      "label": "4188",
      "value": "4b48f0f8-cf54-499f-b8eb-6e5e762d3974"
    },
    {
      "label": "4190",
      "value": "8214b9f7-f6e1-4969-a3f8-267dd0773474"
    },
    {
      "label": "4191",
      "value": "a8225622-eed8-4bff-ae89-3d892c4f0751"
    },
    {
      "label": "4192",
      "value": "6f1df115-19d7-4c57-b817-491c5b7bf95a"
    },
    {
      "label": "4193",
      "value": "97ce0eee-2734-4790-8d70-b09ee5afc069"
    },
    {
      "label": "4194",
      "value": "d33ab0db-d6b3-4b20-8d1c-7ac232bc068d"
    },
    {
      "label": "4197",
      "value": "32cdec42-45a3-4981-b8a9-e041a70e0697"
    },
    {
      "label": "4198",
      "value": "5e14c19c-71f4-43ed-8d49-800bbbd37ef3"
    },
    {
      "label": "4199",
      "value": "b2635d4f-a26e-45fe-a4c0-e99036b79f64"
    },
    {
      "label": "4200",
      "value": "b52b7266-a554-4efa-9921-7e2df3fb4480"
    },
    {
      "label": "4201",
      "value": "2c8a9225-336f-498b-8424-3a3093a744d0"
    },
    {
      "label": "4202",
      "value": "7be75234-4998-4d23-a470-0bfac26c6440"
    },
    {
      "label": "4203",
      "value": "cfed4c03-393a-4a1e-89b4-dd79827477c5"
    },
    {
      "label": "4204",
      "value": "8f4794b9-0f34-47e3-8c6d-c407a7066b4c"
    },
    {
      "label": "4205",
      "value": "d606640d-1314-4322-8963-bf441474c277"
    },
    {
      "label": "4206",
      "value": "0a2456df-932f-42f0-8546-6d01fe1d46c7"
    },
    {
      "label": "4207",
      "value": "2e1b4be0-edc5-48ce-823a-8239c9a75583"
    },
    {
      "label": "4208",
      "value": "f4bcd8e3-50f0-4841-a56c-70b221ec3e27"
    },
    {
      "label": "4209",
      "value": "95e01192-a785-4176-a488-070dbd527af0"
    },
    {
      "label": "4210",
      "value": "6bb144b6-5a58-46b7-afce-38940029084b"
    },
    {
      "label": "4211",
      "value": "61ab0395-3505-4a8c-b3c3-108c5e264007"
    },
    {
      "label": "4212",
      "value": "53eb477e-4a2b-46d5-aba1-693802a59744"
    },
    {
      "label": "4213",
      "value": "4e63b53d-b6e3-4267-9a6e-283e5c442878"
    },
    {
      "label": "4214",
      "value": "819ac965-db4e-4a7f-bf9b-c85c191f52c2"
    },
    {
      "label": "4215",
      "value": "d5fc7de5-6919-4022-b114-f1761bb3527c"
    },
    {
      "label": "4216",
      "value": "cde71cd8-cfda-41b1-85cd-a7e0191b3a0f"
    },
    {
      "label": "4217",
      "value": "eaa6145c-5061-4f9b-b17b-0b44c5679b1c"
    },
    {
      "label": "4218",
      "value": "c1c025d0-9843-4bca-bb0e-926e6f2f3531"
    },
    {
      "label": "4219",
      "value": "6478e048-315a-4e66-892e-e3125d41135c"
    },
    {
      "label": "4220",
      "value": "b1f61209-be5f-497f-8fa2-9338b1637e47"
    },
    {
      "label": "4225",
      "value": "0a9f7f55-fd48-4f75-9ab6-85f79da815eb"
    },
    {
      "label": "4227",
      "value": "bce28fd7-15cc-4f30-aa6e-ef4de72f468a"
    },
    {
      "label": "4228",
      "value": "f03f00c4-2557-4cf8-b935-ba79f4baaf1d"
    },
    {
      "label": "4229",
      "value": "a3fc360b-4d0c-4c39-9f5f-044790a8419f"
    },
    {
      "label": "4233",
      "value": "eaf8d89c-1965-4539-b808-9abb97c4f54b"
    },
    {
      "label": "4234",
      "value": "aaf99815-f4c6-4b1f-bc2d-7cd5d28b9ca3"
    },
    {
      "label": "4235",
      "value": "6e3adca5-ce00-4f01-9df7-0548694c63c9"
    },
    {
      "label": "4236",
      "value": "24c61423-ba90-48b8-be67-64a796401681"
    },
    {
      "label": "4237",
      "value": "b0f16dcb-07c5-4886-80e6-d777639fbf49"
    },
    {
      "label": "4238",
      "value": "12d91134-4945-4458-93ec-1fb8834c76ca"
    },
    {
      "label": "4239",
      "value": "cd5cd0f5-10c9-4113-a696-ac7c4b9cba1c"
    },
    {
      "label": "4240",
      "value": "350e9c24-5e84-4374-9222-cf30935f0928"
    },
    {
      "label": "4241",
      "value": "7cfc6bac-df42-4b86-b17d-db2415a992c4"
    },
    {
      "label": "4242",
      "value": "916917c6-2fc5-4be3-9f10-b0d6a35e2f1d"
    },
    {
      "label": "4243",
      "value": "971a02a4-5288-4128-bee8-a4ba3c81ab32"
    },
    {
      "label": "4244",
      "value": "1ccc652f-4267-4d74-a10b-ce03dd099a2d"
    },
    {
      "label": "565",
      "value": "eee3a860-2a20-4ce7-b68b-d4eb7cac64a8"
    },
    {
      "label": "566",
      "value": "3d3e203a-eece-4923-bb69-42b45bc023a5"
    },
    {
      "label": "8322",
      "value": "c9085bb6-ab01-4964-a67b-d2f4490da4c1"
    },
    {
      "label": "8342",
      "value": "9cb3170e-5024-4173-a7e3-b34ec2eada9a"
    },
    {
      "label": "8372",
      "value": "d76427b4-ca97-4d11-b8f7-45a143a97c9f"
    },
    {
      "label": "8562",
      "value": "d9a7bcb1-df07-4aa9-aeca-ec03def8af98"
    },
    {
      "label": "8952",
      "value": "f0c6e72b-a589-479d-8314-6f455ae2d177"
    }
  ],
  "162d51e5-8fcc-4083-969d-91d5948e58ad": [
    {
      "label": "4358",
      "value": "4d5e3e68-e45e-41d4-b174-1ebe02c2eedd"
    },
    {
      "label": "4359",
      "value": "5ac59e57-e62c-48c9-9249-05e005e8a911"
    },
    {
      "label": "4396",
      "value": "e413938b-d4e7-4f75-b016-3066c604a5cc"
    },
    {
      "label": "4397",
      "value": "772e8e4b-2820-48c3-9c32-de472c1d0b08"
    },
    {
      "label": "4402",
      "value": "820fea1b-69f6-455b-985b-d601b94814be"
    },
    {
      "label": "5539",
      "value": "e6270cfa-142c-4e04-986b-4c66b2ebaff4"
    },
    {
      "label": "5541",
      "value": "f94c8312-6ae9-4255-8aaa-504f2207fc0a"
    },
    {
      "label": "590",
      "value": "0c71f524-67b1-49f4-bc30-37394cc94b3d"
    },
    {
      "label": "591",
      "value": "01ca61d3-a76f-4a5f-a078-1463e446d85e"
    },
    {
      "label": "9670",
      "value": "c11e2366-b3c3-4509-96d9-8a70c0a363b2"
    },
    {
      "label": "9671",
      "value": "601a7148-52a5-490f-8dc0-0dadf051c917"
    },
    {
      "label": "9693",
      "value": "dc6f9dc8-16b9-4db5-9b6a-af07e9125866"
    },
    {
      "label": "9698",
      "value": "26b3b384-068a-4f12-9187-e2b3d15a14e9"
    }
  ],
  "dbc342d7-3116-4462-b059-101e6e5321d0": [
    {
      "label": "2312",
      "value": "30090899-a0d3-4849-8c12-1b228d4c2b99"
    },
    {
      "label": "2313",
      "value": "5101cc85-2f91-41e3-adfc-8e81f0ed9873"
    },
    {
      "label": "6392",
      "value": "1bc96a87-6f2c-4b65-a98a-2d9189e85548"
    },
    {
      "label": "6393",
      "value": "16f17d26-1756-4e04-bff0-c9218ef7aaac"
    },
    {
      "label": "64",
      "value": "2e4f184c-ba6d-4ef8-9a34-a348c65babc0"
    },
    {
      "label": "65",
      "value": "e608a6e3-342e-4f3b-82c6-11dc0c38a56c"
    },
    {
      "label": "7730",
      "value": "73ccd06d-91b2-45bc-9b01-b553c604cacf"
    },
    {
      "label": "7733",
      "value": "4fe7114e-568a-4e5b-95c5-224879bf463e"
    },
    {
      "label": "7734",
      "value": "dbd72c8f-37a1-4597-9406-ac907910e717"
    },
    {
      "label": "7735",
      "value": "bf56a41c-c41d-4790-8fe7-b52b85b5d890"
    },
    {
      "label": "7736",
      "value": "7d226d2d-f2a6-4ff9-8724-ea22e5904f4e"
    },
    {
      "label": "7737",
      "value": "9a529952-9b25-43ad-a709-6de3a7f58eda"
    },
    {
      "label": "7738",
      "value": "8480a888-e175-4550-8947-cbff1c8e2f0a"
    },
    {
      "label": "7739",
      "value": "1eb95f12-af7a-423d-a4cb-3c5a547ed335"
    },
    {
      "label": "7740",
      "value": "e5cc6b30-a22f-4394-b66c-4b57b7f83fb3"
    },
    {
      "label": "7744",
      "value": "dc09a20b-de9c-4350-b0c0-f9d5b1f1a3dd"
    },
    {
      "label": "7746",
      "value": "4440bfe0-7767-4d0f-b949-674f6d092c10"
    },
    {
      "label": "7747",
      "value": "7874be67-61f5-4d6c-88c0-3a9f904b8b7a"
    },
    {
      "label": "7748",
      "value": "26969f5d-7979-4faf-9aac-4b3d4b5ee84b"
    },
    {
      "label": "7749",
      "value": "05f7c25a-f5fa-4711-8aa6-2b00d75a8074"
    },
    {
      "label": "7751",
      "value": "df0bfa0c-f115-453e-b1b1-e2f0f0a1b4f1"
    },
    {
      "label": "7753",
      "value": "ef1628f9-078a-4a6e-8702-0467e397b5e6"
    },
    {
      "label": "7754",
      "value": "c5100ff7-4c22-4e07-bad2-e41255ce3531"
    },
    {
      "label": "7755",
      "value": "93764d7b-95b6-4316-a7c7-32d599d4ff9f"
    },
    {
      "label": "7756",
      "value": "a14ae31f-54b9-4e58-803d-cb37068ea9a4"
    },
    {
      "label": "7757",
      "value": "0eeaa69d-be91-4eda-af7b-4aacae7d3877"
    },
    {
      "label": "7758",
      "value": "fa03f38a-cf8a-43fb-9031-def32ffe8312"
    },
    {
      "label": "7759",
      "value": "59c60887-99cb-4383-81c6-d9bc8155d13c"
    },
    {
      "label": "7760",
      "value": "4d5606fd-e0a0-474b-aa24-118d0cb2d509"
    },
    {
      "label": "7761",
      "value": "149814fd-0622-4e12-b6b9-f03b22723cdb"
    },
    {
      "label": "7762",
      "value": "7cf70d72-86d3-47ff-b647-b11181467b0a"
    },
    {
      "label": "7763",
      "value": "40fd94f5-810f-471a-b412-4467216ba5f9"
    },
    {
      "label": "7764",
      "value": "47218a1f-46a8-4de7-8fa6-3f495347cfb3"
    },
    {
      "label": "7765",
      "value": "9fa75381-028b-4388-9624-e411ed829a89"
    },
    {
      "label": "7766",
      "value": "51cf068f-e734-4cb8-9bc3-7af83833874c"
    }
  ],
  "e06857bb-1c0a-4207-84b4-bee92116a8d9": [
    {
      "label": "201",
      "value": "f3477dde-b6a5-4dec-b919-a3dc013b9ac5"
    },
    {
      "label": "203",
      "value": "df0bfe47-2efb-4416-8b10-2dbdc23a4517"
    },
    {
      "label": "205",
      "value": "a340d1e8-6059-4423-a30c-ffb7a91909f3"
    },
    {
      "label": "211",
      "value": "18c36730-b7ee-4300-b331-9892aa41d413"
    },
    {
      "label": "225",
      "value": "6b1e519a-f865-48ee-8c73-d5705c1e2e61"
    },
    {
      "label": "231",
      "value": "3616cfc1-ef4c-4a44-8d96-b3599a178241"
    },
    {
      "label": "235",
      "value": "521be3bb-c74d-4473-bdd8-c5b0af9a4bf0"
    },
    {
      "label": "2476",
      "value": "5f469e04-5e28-48fc-9e3d-9a7f03c4d43b"
    },
    {
      "label": "2477",
      "value": "f416e320-113f-4568-b094-a6c3afa86fce"
    },
    {
      "label": "719",
      "value": "4abdb441-fb7d-469f-bf65-64bf745b0d28"
    },
    {
      "label": "720",
      "value": "aa0677d2-aaab-40d2-9661-3b0293d06890"
    },
    {
      "label": "721",
      "value": "d9004799-bae1-4ff0-aa10-fbbc4073740f"
    },
    {
      "label": "722",
      "value": "6691b3a9-4efa-4b9c-8460-3012d3876a35"
    },
    {
      "label": "9747",
      "value": "3e8993ca-1b9e-46d3-b046-34594b4934a4"
    }
  ]
}

export const KE_FIELDS = {
  visited_over_3_times: {
    type: 'yes-no-buttons'
  },
  denied_entry: {
    type: 'yes-no-buttons'
  },
  employment: {
    type: {
      type: 'autocomplete',
      props: {
        label: 'Employment Type',
        options: [
          { label: "Accommodation, Hospitality and Catering Professional", value: "c543cfb9-719f-4b4c-9601-ffd6c243c86d" },
          { label: "Accountant, Economist, Finance Professional", value: "331cb154-82a1-41c2-8eb6-02e101556cf9" },
          { label: "Actor", value: "27d8f015-6cd9-4fb3-9c69-6ae6e56a94ed" },
          { label: "Advertising and Marketing Professional", value: "9cdd72b2-b7d9-4c73-9901-3c9c024656f3" },
          { label: "Agricultural, Agronomy, Fisheries and Forestry Professional", value: "0dc5bc8c-f047-46e7-a5ec-629733f8550b" },
          { label: "Air or Maritime Transport Professional", value: "f2900a1d-f0ba-45e9-b6ef-7021404edab2" },
          { label: "Archaeologist", value: "fc38b52d-00ea-4ad2-b924-3677fe943ad2" },
          { label: "Architects and Landscape Professional", value: "23f81695-4a6c-4538-9531-074c31f3802f" },
          { label: "Author", value: "5769ca63-02d5-44b5-9e29-bc369e2e43b2" },
          { label: "Chief Executive and Managing Director", value: "8ce33777-0541-4fa2-9bb3-381de2af2011" },
          { label: "Conference and Event Professional", value: "a9e62f5f-6c74-4683-8b48-099a2c185eaa" },
          { label: "Cyber Security Developer", value: "1ec4ca0e-77bf-466b-810d-2a7799a26ad9" },
          { label: "Dancer or Choreographer", value: "630135c2-51b1-487a-885f-f5efaa60ad13" },
          { label: "Driver", value: "708a4c88-f581-4e33-b44d-a226bef8b0d2" },
          { label: "Electrician", value: "c79b8196-810d-4dd9-accb-863dca89315f" },
          { label: "Engineer", value: "5a5bb164-9847-4435-aa99-1fe97c4d633c" },
          { label: "Fire Fighter", value: "d2261ded-00cd-48b6-9a93-e871c29772c4" },
          { label: "Florist", value: "bfac5096-99b5-49ef-a82c-5ea1342903e6" },
          { label: "Employee (government entities)", value: "52fa2eff-e476-461f-9b8e-911320199252" },
          { label: "Graphic and Web Designer, Illustrator", value: "243b8410-5540-4ae3-bcf6-952083eaff77" },
          { label: "Hairdresser", value: "304d056a-59f9-408a-a027-98ff7e6a0296" },
          { label: "Historian", value: "ca7cc5f1-e3cf-424a-a978-13058af94882" },
          { label: "Housekeeper", value: "e1c180bd-21af-435f-83eb-3292b6e9d8e5" },
          { label: "Human Resource Manager", value: "a37b868f-0ecc-4ff2-acae-8b210269920d" },
          { label: "ICT Professional", value: "11fd5ac6-3e15-4419-a0bd-5cffb1485dd5" },
          { label: "Importers, Exporters and Wholesaler", value: "6d46fd01-bf4e-4be4-929e-18883d0d7d3e" },
          { label: "Jeweller", value: "8e0e2a22-6126-49e0-aedd-a1588ad07e6a" },
          { label: "Journalist, Blogger", value: "61f3c4e2-b748-403b-a705-ec600d9c7c56" },
          { label: "Judicial and other Legal Professional", value: "e6179350-637f-4476-91fd-91a037d36508" },
          { label: "Librarian", value: "2b009e93-d9f0-49a9-9a15-7e715db757e4" },
          { label: "Lobbyist", value: "11752c74-33e9-44b7-8ebf-f110f1a32a9e" },
          { label: "Manufacturer", value: "8a1156b6-6a05-49b6-af36-a0059d63f345" },
          { label: "Medical Practicioner", value: "a694dc45-8bc3-47c7-9d4b-3030f8710b88" },
          { label: "Meteorologist", value: "21ffae15-0ef2-4696-b5dc-09904804a617" },
          { label: "Military", value: "afc17744-4d13-42a5-94ab-720cffe4b495" },
          { label: "Minister of Religion", value: "137ef27f-655f-43ec-bf64-94ff5a119f73" },
          { label: "Multimedia Specialist and Web Developer", value: "d09d19cb-75f3-4faf-b18c-858432861dc9" },
          { label: "Music Professional", value: "ced60e76-632e-47fb-9ca8-c3c0310d5fb4" },
          { label: "Photographer", value: "fefdd90b-bc11-4ed5-b7ba-8fd32d181814" },
          { label: "Plumber", value: "aa24c81d-1a38-4609-842a-d6a03d0fd194" },
          { label: "Police Officer", value: "e2ffee37-4b73-49fa-b9a3-17ebdaa26783" },
          { label: "Project Manager", value: "cec6d9e1-8797-4eaa-9112-aa011c03b050" },
          { label: "Public Relations Professional", value: "8b70a30c-2f50-4117-b70f-20a1b4e58ec9" },
          { label: "Research and Development", value: "4df87952-747a-469c-95af-3cbafa269dd6" },
          { label: "Sales Professional", value: "f61dbfab-7e98-458e-87a2-5cdf5d2cb075" },
          { label: "School Teacher, University Lecturer and Tutor", value: "84232a53-da34-4b04-a8c9-8136ebf0460d" },
          { label: "Self-employed", value: "83c78dbd-ed22-4953-b930-3d2fe52f939a" },
          { label: "Social Worker", value: "810b067f-037e-4945-a6eb-98b5dcd66484" },
          { label: "Software and Applications Programmer", value: "898dc113-783a-489d-bbcc-0527fa118eb5" },
          { label: "Sports Coach, Instructor", value: "8ab1e3bd-a0df-405e-9b7f-3ce237d4ad2a" },
          { label: "Student", value: "83a21d02-9386-4065-866a-93606e3e68c8" },
          { label: "Supply, Distribution and Procurement Professional", value: "e27728c8-f1ae-4338-9b08-8c400c5d48a5" },
          { label: "Translator", value: "0d906993-f119-4817-bd81-d304b3461b2a" },
          { label: "Veterinarian", value: "d1bf5ba6-085b-4345-af29-312e11fd5a4a" },
          { label: "Other", value: "f88ec1b2-2b02-4f62-9bce-e63ab7e4dd4c" }
        ]
      }
    },
    details: {
      type: "input",
      props: {
        label: "Occupation",
        maxLength: 70
      }
    }
  }
}

// Vessel numbers keyed by cruise line / vessel owner uuid (exit_vessel). Lines with no
// entry here hide the vessel-number select automatically (mapped-select behaviour).
const KE_VESSELS = {
  // Viking Cruises
  "a70689d4-b2f2-473e-82c4-628c5534559b": [
    { label: "OSK241219G", value: "c3c4a173-0bd3-4978-b292-7eb8395ff7c6" },
    { label: "OSK241219J", value: "f2b0471d-8a9f-4716-afaa-fcae6fcb1a64" },
    { label: "OSK25010F", value: "a6ba987c-ecc2-4201-9009-4080de134c6d" },
    { label: "OSK25010I", value: "8b676cea-30e8-4fd0-8d2e-c69c47ada454" }
  ],
  // MSC Cruises
  "b87d60cd-e579-4d7b-891c-7b4e2ef7a881": [
    { label: "3EPL4", value: "a33c5da1-6363-4bd1-93d2-4e06895232cc" }
  ],
  // Phoenix Reisen GmbH
  "eb7eb094-8438-4396-8f3c-01182cf557d0": [
    { label: "9141807", value: "043d6544-f9bc-4088-af03-cc4aba9cf400" }
  ],
  // Holland America Line
  "c2179c03-0a7c-41ae-8042-3e1c6f5c6df9": [
    { label: "PBIG", value: "70cafc6e-9efc-4a8f-b9fb-6d109ea8add9" }
  ],
  // Private
  "8339d2fd-2be8-465d-867c-3940c12eb10e": [
    { label: "PY", value: "4b12dab7-d8cb-4e38-b678-ea249300ffc4" }
  ],
  // Norwegian Cruise Line
  "bd3e4b77-06b9-4bcc-b5f1-304a5160d3d3": [
    { label: "C6FT7", value: "07799ec7-60ec-41b2-bc1c-3e3048d31cfa" }
  ],
  // Hapag-Lloyd Cruises
  "53e5cb2f-b798-4cfd-a2df-f9b6bf7e73f6": [
    { label: "9HA5275", value: "e2393de5-6ff9-49b1-9e92-198a7d3625ae" }
  ],
  // Seabourn Cruise Line
  "dde024f3-db54-47ae-8008-e317dccee35e": [
    { label: "C6YA5", value: "60737bc4-82a7-4a20-b3c1-55523269fd99" }
  ],
  // Swan Hellenic Cruises
  "4ef5b792-7ab0-4db7-8842-b9b9a819543c": [
    { label: "3E3879", value: "e4895371-e1ee-457b-bf7b-ba085827936a" }
  ]
}

export const KE_APPLICATION_FIELDS = {
  financed_by_third_party: {
    type: 'yes-no-buttons'
  },
  reason: {
    type: 'select',
    props: {
      label: 'Purpose of Visit',
      options: [
				{ label: "Seaman (Fishing Vessel)", value: "5f757f0a-01f1-42e2-8cdc-7047dc8d5bff" },
				{ label: "Work", value: "a24b07cf-e313-4718-a0db-49312e47511f" },
				{ label: "Business", value: "9b99b3e3-2d33-4101-b3eb-e94ae10fb30c" },
				{ label: "Conference / Meetings / Seminars / Training", value: "c03bbe11-bead-4434-8c3c-d1e1b7aabcd1" },
				{ label: "Crew (planes or ships)", value: "45ff7956-8855-4e40-83b6-82cacb9dd289" },
				{ label: "Crew (Positioning)", value: "266bcc5a-4e08-4ff6-bbad-c7e0d78a6bde" },
				{ label: "Tourism", value: "b2aef8c2-01c6-4cc9-a2db-fff3b3e227bf" },
				{ label: "Friends & Family", value: "3c1feabb-adf6-4af6-b68b-e9a232f510f6" },
				{ label: "Medical Care", value: "8f346d57-c821-4ecb-b480-fb67b739632e" },
				{ label: "Religious Visit", value: "885bd084-e610-488b-b205-001891733014" },
				{ label: "Study / Education", value: "58256f2f-d5ee-4db2-a128-32cc1e141866" },
				{ label: "Transit", value: "da4dc7b4-fc94-4796-864d-32d3b6581c91" }
      ]
    }
  },
  entry_type:{
    type: "buttons",
    props: {
      options: [
        {
          icon: "icon-air",
          label: "Air",
          value: "air"
        },
        {
          icon: "icon-sea",
          label: "Sea",
          value: "sea"
        },
        {
          icon: "icon-land",
          label: "Land",
          value: "land"
        }
      ]
    }
  },
  exit_type:{
    type: "buttons",
    props: {
      options: [
        {
          icon: "icon-air",
          label: "Air",
          value: "air"
        },
        {
          icon: "icon-sea",
          label: "Sea",
          value: "sea"
        },
        {
          icon: "icon-land",
          label: "Land",
          value: "land"
        }
      ]
    }
  },
  entry_origin_country: {
    type: "country-autocomplete",
    props: {
      label: 'Country of Origin',
    }
  },
  exit_destination_country: {
    type: "country-autocomplete",
    props: {
      label: 'Destination Country',
    }
  },
  entry_airline: {
    type: 'autocomplete',
    props: {
      label: 'Airline',
      options: KE_AIRLINES  
    }
  },
  entry_flight_number: {
    type: 'mapped-select',
    props: {
      label: 'Flight Number',
      parentKey: 'entry_airline',
      mappedOptions: KE_FLIGHTS
    }
  },
  entry_airline_other: {
    type: 'input',
    props: {
      label: 'Airline',
      maxLength: 100
    }
  },
  entry_flight_number_other: {
    type: 'input',
    props: {
      label: 'Flight Number',
      maxLength: 10
    }
  },
  entry_land_border: {
    type: 'autocomplete',
    props: {
      label: 'Entry Land Border',
      options: KE_LAND_BORDERS      
    }
  },
  exit_airline: {
    type: 'autocomplete',
    props: {
      label: 'Airline',
      options: KE_AIRLINES   
    }
  },
  exit_flight_number: {
    type: 'mapped-select',
    props: {
      label: 'Flight Number',
      parentKey: 'exit_airline',
      mappedOptions: KE_FLIGHTS
    }
  },
  exit_airline_other: {
    type: 'input',
    props: {
      label: 'Airline',
      maxLength: 100
    }
  },
  exit_flight_number_other: {
    type: 'input',
    props: {
      label: 'Flight Number',
      maxLength: 10
    }
  },
  exit_vessel: {
    type: 'autocomplete',
    props: {
      label: 'Cruise Line / Vessel Owner',
      options: [
        { label: "Viking Cruises", value: "a70689d4-b2f2-473e-82c4-628c5534559b" },
        { label: "MSC Cruises", value: "b87d60cd-e579-4d7b-891c-7b4e2ef7a881" },
        { label: "Phoenix Reisen GmbH", value: "eb7eb094-8438-4396-8f3c-01182cf557d0" },
        { label: "Holland America Line", value: "c2179c03-0a7c-41ae-8042-3e1c6f5c6df9" },
        { label: "Private", value: "8339d2fd-2be8-465d-867c-3940c12eb10e" },
        { label: "Norwegian Cruise Line", value: "bd3e4b77-06b9-4bcc-b5f1-304a5160d3d3" },
        { label: "Hapag-Lloyd Cruises", value: "53e5cb2f-b798-4cfd-a2df-f9b6bf7e73f6" },
        { label: "Seabourn Cruise Line", value: "dde024f3-db54-47ae-8008-e317dccee35e" },
        { label: "Swan Hellenic Cruises", value: "4ef5b792-7ab0-4db7-8842-b9b9a819543c" }
      ]
    }
  },
  exit_vessel_number: {
    type: 'mapped-select',
    props: {
      label: 'Vessel Number',
      parentKey: 'exit_vessel',
      mappedOptions: KE_VESSELS
    }
  },
  entry_airport: {
    type: 'autocomplete',
    props: {
      label: 'Entry Airport',
      options: [
        { label: "Eldoret International Airport", value: "2d29dc86-c9e8-4b69-a0ad-04e838119d0e" },
        { label: "Isiolo Airport", value: "9a89c617-8434-4e01-8da1-75def4598191" },
        { label: "Jomo Kenyatta International Airport", value: "b268977d-4556-4253-9388-b774ec1b4df2" },
        { label: "Kisumu Airport", value: "0abfef78-1415-49bd-8916-a840e031f75a" },
        { label: "Lokichoggio Airport", value: "fa88f091-d196-4b5d-adc1-01e60b2238bc" },
        { label: "Malindi Airport", value: "89af3040-05b0-4189-b030-198bf9dc9f68" },
        { label: "Mombasa International Airport", value: "7bd265a2-4d86-43ce-a8cb-bb46b8fa5ce3" },
        { label: "Wajir Airport", value: "75b13ea1-b2ad-4fcc-98e4-f41f97fe9fec" },
        { label: "Wilson Airport", value: "df624426-dbcd-4781-bb49-48c09feb8bf9" }
      ]      
    }
  },
  exit_land_border: {
    type: 'autocomplete',
    props: {
      label: 'Exit Land Border',
      options: KE_LAND_BORDERS      
    }
  },
  exit_airport: {
    type: 'autocomplete',
    props: {
      label: 'Exit Airport',
      options: KE_AIRPORTS      
    }
  },
  hotels: {
    type: "multiple",
    fieldArray: {
      "fieldGroup": [
        {
          "key": "name",
          "type": "name-field",
          "props": {
            "label": "Hotel Name",
            "required": true
          },
          "className": "gwc-form__field gwc-form__field--tight"
        },
        {
          fieldGroup: [
            {
              "key": "from",
              "type": "datepicker",
              "props": {
                "view": "multi-year",
                "label": "From",
                "required": true,
                "after": [
                  {
                    "key": "application.date_of_entry",
                    "parent": "global",
                    "message": "Date can’t be before Date of Entry"
                  }
                ],
                "before": [
                  {
                    "key": "application.date_of_exit",
                    "parent": "global",
                    "message": "Date can’t be after Date of Exit"
                  }
                ]
              },
              "className": "gwc-form__field gwc-form__field--tight gwc-form__field--grow"
            },
            {
              "key": "to",
              "type": "datepicker",
              "props": {
                "view": "multi-year",
                "label": "To",
                "required": true,
                "after": [
                  {
                    "key": "application.date_of_entry",
                    "parent": "global",
                    "message": "Date can’t be before Date of Entry"
                  }
                ],
                "before": [
                  {
                    "key": "application.date_of_exit",
                    "parent": "global",
                    "message": "Date can’t be after Date of Exit"
                  }
                ]
              },
              "className": "gwc-form__field gwc-form__field--tight gwc-form__field--grow"
            }
          ],
          fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
        }
      ]
    },
  },
  over_10k: {
    answer: {
      type: 'yes-no-buttons'
    }
  },
  parental_consent: {
    props: {
      type: 'pdf_document',
      message: 'Applicants under 18 must provide a consent form signed by a parent or legal guardian. Please upload the completed parental consent form.',
      friendly_name: 'Parental Consent Form'
    }
  },
  invitation_letter: {
    props: {
      type: 'pdf_document',
      message: 'Please upload the invitation letter from your host in Kenya.',
      friendly_name: 'Invitation Letter'
    }
  },
  host_id: {
    props: {
      type: 'pdf_document',
      message: "Please upload a copy of your host's ID.",
      friendly_name: "Host's ID"
    }
  }
}

